import type { Messages } from "./en";

/** Turkish UI strings — must cover every MessageKey. */
export const tr: Messages = {
  "app.brand": "SemantiCAD",
  "palette.explorer": "Gezgin",
  "palette.drawings": "Çizimler",
  "palette.drawingsShort": "Çizimler",
  "palette.stock": "Stok kataloğu",
  "palette.stockShort": "Stok",
  "palette.profile": "Profil",
  "palette.profileShort": "Profil",
  "palette.signOutShort": "Çıkış",
  "palette.navPrimary": "Ana gezinme",
  "palette.select": "Seçim",
  "palette.measure": "Ölçüm",
  "palette.bom": "BOM",
  "palette.reports": "Raporlar",
  "palette.orchestration": "Üretim asistanı",
  "palette.erpShort": "ERP",
  "palette.erp": "Atölye ERP",
  "palette.rfq": "RFQ",
  "palette.rfqShort": "RFQ",
  "palette.aiShort": "AI",
  "palette.home": "Ana sayfa",
  "palette.homeShort": "Ana sayfa",

  "sidebar.ariaMain": "Ana",
  "sidebar.markAria": "SemantiCAD ana sayfa",
  "sidebar.orgMarkAria": "{name} ana sayfa",
  "sidebar.show": "Kenar çubuğunu göster",
  "sidebar.collapse": "Kenar çubuğunu daralt",
  "sidebar.openMenu": "Menüyü aç",
  "sidebar.closeMenu": "Menüyü kapat",
  "sidebar.workspace": "Çalışma alanı",
  "sidebar.production": "Üretim",
  "sidebar.group.ai": "YZ",
  "sidebar.group.data": "Veri",
  "sidebar.documents": "Belgeler",
  "sidebar.agents": "Ajanlar",
  "sidebar.soon": "Yakında",
  "sidebar.comingSoon": "Yakında",
  "sidebar.stock": "Stok ve malzemeler",
  "sidebar.integrations": "Entegrasyonlar",
  "notFound.code": "404",
  "notFound.title": "Sayfa bulunamadı",
  "notFound.body": "Bu adres SemantiCAD'de bir sayfaya karşılık gelmiyor.",
  "notFound.home": "Ana sayfaya dön",
  "sidebar.settings": "Ayarlar",
  "sidebar.hint.home": "Özet, kısayollar ve son işler",
  "sidebar.hint.drawings": "Parçalar, BOM'lar ve kataloglar",
  "sidebar.hint.rfq": "Teklifler, müşteriler ve tedarikçiler",
  "sidebar.hint.erp": "Siparişler, stok ve atölye",
  "sidebar.hint.ai": "Bir iş hakkında SemantiCAD'e sor",
  "sidebar.hint.profile": "Hesap, ekip ve çalışma alanı",
  "sidebar.hint.customers": "RFQ e-postalarından gruplanan müşteriler",
  "sidebar.hint.integrations": "Entegrasyonlar henüz kullanılamıyor.",
  "palette.customers": "Müşteriler",

  "customers.title": "Müşteriler",
  "customers.sub": "Her RFQ'daki e-postaya göre gruplanır.",
  "customers.search": "Ad, e-posta veya alan adı ara",
  "customers.notificationsEmpty": "Sizi bekleyen bir şey yok.",
  "customers.filters": "Müşterileri süz",
  "customers.filter.all": "Tümü",
  "customers.filter.active": "Aktif",
  "customers.filter.open": "Açık teklifi var",
  "customers.filter.won": "Daha önce kazanıldı",
  "customers.col.customer": "Müşteri",
  "customers.col.company": "Firma",
  "customers.companyHint": "E-posta alan adı",
  "customers.col.rfqs": "RFQ",
  "customers.col.open": "Açık teklif",
  "customers.col.quoted": "Teklif toplamı",
  "customers.col.wonLost": "Kazanılan / Kaybedilen",
  "customers.col.lastRfq": "Son RFQ",
  "customers.col.activity": "Son hareket",
  "customers.col.rfq": "RFQ",
  "customers.col.parts": "Parçalar",
  "customers.col.status": "Durum",
  "customers.empty": "Henüz müşteri yok. Bir RFQ e-posta taşıdığında müşteri görünür.",
  "customers.noMatch": "Bu filtreye uyan müşteri yok.",
  "customers.back": "Müşteriler",
  "customers.missing": "Bu adrese uyan müşteri yok.",
  "customers.firstSeen": "İlk geliş {date}",
  "customers.kpi.rfqs": "RFQ",
  "customers.kpi.quoted": "Teklif",
  "customers.kpi.won": "Kazanılan",
  "customers.kpi.win": "Kazanma oranı",
  "customers.kpi.response": "Yanıt",
  "customers.kpi.responseHint": "Oluşturulmadan teklif gönderimine ortalama",
  "customers.history": "RFQ'lar",
  "customers.activity": "Hareket",
  "customers.activityEmpty": "Bu RFQ'larda tarihli olay yok.",
  "customers.mailError": "Gelen kutusu yüklenemedi.",
  "customers.due": "Termin",
  "customers.quote": "Teklif",
  "customers.target": "Hedef {amount}",
  "customers.contacts": "Kişiler",
  "customers.notes": "Notlar",
  "customers.soon": "Yakında",
  "customers.contactsBody": "Kişiler henüz kaydedilmiyor.",
  "customers.notesBody": "Müşteri notları henüz kaydedilmiyor.",
  "customers.step.uploaded": "Yüklendi",
  "customers.step.bom": "BOM",
  "customers.step.costed": "Maliyetlendi",
  "customers.step.quoted": "Tekliflendi",
  "customers.mark.costed": "Maliyetlendi",
  "customers.mark.decided": "Karar verildi",
  "customers.mark.unreadable": "Dosya okunamadı",
  "customers.mark.skipped": "Satır atlandı",
  "customers.mark.okLegend": "Maliyetlendi veya karar verildi",
  "customers.mark.badLegend": "Okunamadı veya atlandı",
  "customers.attention": "İlgilenilmeli",
  "customers.moreParts": "+{n}",
  "customers.event.received": "{no} alındı",
  "customers.event.sent": "Teklif gönderildi · {no}",
  "customers.event.won": "Kazanıldı · {no}",
  "customers.event.lost": "Kaybedildi · {no}",
  "customers.event.outcome": "{status} · {no}",
  "customers.event.waiting": "Müşteri bekleniyor · {no}",
  "customers.event.reply": "Müşteri yanıtı · {no}",
  "customers.event.mailIn": "Gelen posta · {no}",
  "customers.event.mailOut": "Giden posta · {no}",
  "customers.event.mail": "Posta · {no}",
  "customers.reason.price": "Fiyat",
  "customers.reason.lead": "Termin",
  "customers.reason.capacity": "Kapasite",
  "customers.reason.no_bid": "Teklif yok",
  "customers.source.catalog_part": "Katalog parçası",
  "customers.source.catalog_bom": "Katalog BOM",
  "customers.source.upload_job": "Yükleme",
  "customers.source.manual": "Elle",
  "customers.source.intake": "İçeri alma",
  "customers.duration.min": "{n} dk",
  "customers.duration.hour": "{n} sa",
  "customers.duration.day1": "1 gün",
  "customers.duration.days": "{n} gün",
  "customers.kpi.customers": "Müşteriler",
  "customers.kpi.openQuotes": "Açık teklif",
  "customers.kpi.quotedTotal": "Teklif toplamı",
  "customers.kpi.wonBefore": "Daha önce kazanıldı",
  "customers.export": "Dışa aktar",
  "customers.bulk.one": "{n} müşteri seçildi",
  "customers.bulk.many": "{n} müşteri seçildi",
  "customers.bulk.export": "Dışa aktar",
  "customers.bulk.merge": "Birleştir",
  "customers.bulk.clear": "Seçimi temizle",
  "customers.menu.more": "Diğer",
  "customers.menu.open": "Müşteriyi aç",
  "customers.menu.rfqs": "RFQ'ları göster",
  "customers.menu.quote": "Müşteri için yeni teklif",
  "customers.menu.merge": "Şununla birleştir…",
  "customers.mergeUnavailable": "Müşteri birleştirme henüz yok.",
  "customers.emptyTitle": "Henüz müşteri yok",
  "customers.emptyBody": "Müşteriler, her RFQ'daki e-postadan oluşur.",
  "customers.noMatchTitle": "“{query}” ile eşleşen müşteri yok",
  "customers.noMatchHint": "Bir ad, e-posta veya alan adı dene.",
  "customers.range": "{from}–{to} / {total}",
  "customers.select": "{name} seç",
  "customers.col.email": "E-posta",
  "stock.title": "Stok ve malzemeler",
  "stock.sub": "Eldeki stok. Açık talep, yalnızca stok kalemini adlandıran RFQ satırlarını sayar.",
  "stock.search": "Parça, malzeme veya ad ara",
  "stock.filters": "Malzemeleri süz",
  "stock.filter.all": "Tümü",
  "stock.filter.in": "Stokta",
  "stock.filter.short": "Eksik",
  "stock.filter.reserved": "Rezerve",
  "stock.kpi.materials": "Malzemeler",
  "stock.kpi.in": "Stokta",
  "stock.kpi.short": "Eksik",
  "stock.kpi.demand": "Açık talep",
  "stock.col.material": "Malzeme",
  "stock.col.type": "Tür",
  "stock.col.size": "Ölçü",
  "stock.col.qty": "Miktar",
  "stock.col.demand": "Talep",
  "stock.col.names": "Adlar",
  "stock.col.match": "Son RFQ",
  "stock.col.sizeHint": "Kayıtlı eşleşme ölçüleri",
  "stock.col.qtyHint": "Kullanılabilir miktar; yoksa eldeki",
  "stock.col.demandHint": "Bu kalemi adlandıran açık RFQ satırlarının miktarı",
  "stock.col.namesHint": "Bu stok koduna bağlanan kayıtlı adlar",
  "stock.col.matchHint": "Bu kalemi adlandıran en yeni RFQ",
  "stock.export": "Dışa aktar",
  "stock.import": "CSV içe aktar",
  "stock.add": "Malzeme ekle",
  "stock.reimport": "Yeniden içe aktar",
  "stock.imported": "Son içe aktarma {date}, {name}",
  "stock.notificationsEmpty": "Seni bekleyen bir şey yok.",
  "stock.bulk.one": "{n} malzeme seçili",
  "stock.bulk.many": "{n} malzeme seçili",
  "stock.bulk.export": "Dışa aktar",
  "stock.bulk.clear": "Seçimi temizle",
  "stock.menu.more": "Diğer",
  "stock.menu.copy": "Parça numarasını kopyala",
  "stock.menu.open": "RFQ'yu aç",
  "stock.menu.link": "İstenen adı bağla",
  "stock.menu.remove": "{name} adını kaldır",
  "stock.copied": "{part} kopyalandı",
  "stock.copyFailed": "Parça numarası kopyalanamadı.",
  "stock.select": "{name} seç",
  "stock.range": "{from}–{to} / {total}",
  "stock.emptyTitle": "Henüz malzeme yok",
  "stock.emptyBody": "Bir malzeme ekle veya CSV içe aktar.",
  "stock.noMatchTitle": "“{query}” ile eşleşen yok",
  "stock.noMatchHint": "Bir parça numarası, malzeme veya kayıtlı ad dene.",
  "stock.noMatch": "Bu süzgeçle eşleşen malzeme yok.",
  "stock.demand.none": "Açık RFQ yok",
  "stock.demand.one": "{qty}{unit} · 1 RFQ",
  "stock.demand.many": "{qty}{unit} · {n} RFQ",
  "stock.demand.enough": "Yeterli",
  "stock.demand.short": "{n}{unit} eksik",
  "stock.belowMin": "Asgarinin {n}{unit} altında",
  "stock.reservedLine": "{n}{unit} rezerve",
  "stock.unmatched": "{n} kayıtlı ad bir stok koduyla eşleşmiyor.",
  "stock.form.part": "Parça numarası",
  "stock.form.description": "Açıklama",
  "stock.form.material": "Malzeme",
  "stock.form.unit": "Birim",
  "stock.form.qty": "Miktar",
  "stock.form.save": "Kaydet",
  "stock.form.cancel": "Vazgeç",
  "stock.form.requested": "Bu ad istendiğinde",
  "stock.form.useStock": "Bu stoku kullan",
  "stock.linked": "{name} adı {code} için kaydedildi.",
  "stock.removed": "{name} kayıtlı adı kaldırıldı.",
  "stock.file": "CSV veya Excel dosyası",
  "subnav.collapse": "Paneli daralt",
  "subnav.expand": "Paneli genişlet",
  "subnav.hidePanel": "Paneli gizle",
  "subnav.showPanel": "Paneli göster",

  "drawings.title": "Parçalar ve BOM'lar",
  "drawings.sub": "Bu organizasyonun BOM malzemeleri ve çizimleri",
  "drawings.col.id": "İş",
  "drawings.open": "Aç",
  "drawings.actions": "İşlemler",
  "drawings.download": "İndir",
  "drawings.downloadFailed": "Dosya indirilemedi.",
  "drawings.delete": "Sil",
  "drawings.deleteTitle": "Çizim silinsin mi?",
  "drawings.deleteConfirm": "Bu çizim işini silmek istiyor musunuz? Geri alınamaz.",
  "drawings.deleteCancel": "İptal",
  "drawings.deleteFailed": "İş silinemedi.",
  "drawings.bomToggle": "BOM parçaları ve stok eşleşmesi",
  "drawings.bomLoading": "Parçalar yükleniyor…",
  "drawings.bomEmpty": "Henüz BOM satırı yok",
  "drawings.bomLoadFailed": "BOM yüklenemedi",
  "drawings.bomPartFallback": "Parça {{n}}",
  "drawings.backToList": "Tüm çizimler",
  "drawings.dropTitle": "Parse için bırakın",
  "drawings.dropHint": "Yüklemek ve üretim analizini başlatmak için bırakın",
  "drawings.dropBusy": "Parse zaten çalışıyor",
  "drawings.dropBusyHint": "Mevcut iş bitsin, sonra tekrar bırakın",
  "drawings.dropUnsupported": "DXF, STEP veya DWG dosyası kullanın.",
  "drawings.status.ready": "Hazır",
  "drawings.status.parsing": "Okunuyor",
  "drawings.status.pending": "Bekliyor",
  "drawings.status.partial": "Kısmi",
  "drawings.status.failed": "Hata",
  "drawings.status.review": "İnceleme",
  "drawings.status.unknown": "—",
  "drawings.noPreview": "Önizleme yok",

  "home.greeting.morning": "Günaydın, {name}!",
  "home.greeting.afternoon": "İyi günler, {name}!",
  "home.greeting.evening": "İyi akşamlar, {name}!",
  "home.greeting.morningAnon": "Günaydın!",
  "home.greeting.afternoonAnon": "İyi günler!",
  "home.greeting.eveningAnon": "İyi akşamlar!",
  "home.kpi.parts": "Parçalar",
  "home.kpi.boms": "BOM'lar",
  "home.kpi.review": "İnceleme",
  "home.kpi.orders": "Açık sipariş",
  "home.actions": "Hızlı işlemler",
  "home.action.upload": "Çizim yükle",
  "home.action.uploadHint": "STEP, DXF veya DWG dosyasını BOM'a çevirin.",
  "home.action.uploadCta": "Dosya aç",
  "home.action.parts": "Parçaları gör",
  "home.action.partsHint": "Çizimlerdeki BOM malzemelerine bakın.",
  "home.action.partsCta": "Parçaları gör",
  "home.action.boms": "BOM'ları gör",
  "home.action.bomsHint": "Çizimleri ve montajları BOM olarak açın.",
  "home.action.bomsCta": "BOM'ları gör",
  "home.action.erp": "ERP'yi aç",
  "home.action.erpHint": "Stok, satın alma ve iş emirleri.",
  "home.action.erpCta": "ERP'yi aç",
  "home.data": "Hızlı veri",
  "home.review.title": "İnceleme bekleyen",
  "home.review.empty": "İnceleme bekleyen çizim yok.",
  "home.review.view": "Kataloğu aç",
  "home.activity.title": "Son hareketler",
  "home.activity.empty": "Henüz bir şey yok.",
  "home.activity.view": "ERP'yi aç",

  "catalog.all": "Tüm öğeler",
  "catalog.parts": "Parçalar",
  "catalog.boms": "BOM'lar",
  "catalog.search": "Ara",
  "catalog.searchPh": "Parça ve BOM ara",
  "catalog.empty": "Bu filtreye uyan öğe yok.",
  "catalog.partsLoading": "Parçalar yükleniyor…",
  "catalog.loading": "Katalog yükleniyor…",
  "catalog.cost": "Maliyet",
  "catalog.qty": "Eldeki miktar",
  "catalog.description": "Açıklama",
  "catalog.items": "Öğe",
  "catalog.usedIn": "{n} BOM'da kullanılıyor",
  "catalog.folders": "Klasörler",
  "catalog.count": "{n}",
  "catalog.layout.aria": "Katalog görünümü",
  "catalog.layout.grid": "Izgara",
  "catalog.layout.list": "Liste",
  "catalog.kind.part": "Parça",
  "catalog.kind.bom": "BOM",

  "rfq.title": "RFQ tahminleri",
  "rfq.subtitle": "Her parça veya BOM’un nasıl üretileceğine ve ne kadar süreceğine karar verin",
  "rfq.new": "Yeni RFQ",
  "rfq.newTitle": "Başlıksız RFQ",
  "rfq.search": "RFQ no veya başlık ara…",
  "rfq.list.title": "RFQ",
  "rfq.list.search": "Firma, iş veya RFQ numarası ara",
  "rfq.list.newQuote": "Yeni RFQ",
  "rfq.list.filters": "Duruma göre süz",
  "rfq.list.filter.all": "Tümü",
  "rfq.list.filter.bom": "BOM incelemesi bekliyor",
  "rfq.list.filter.cost": "Maliyetlemeye hazır",
  "rfq.list.filter.quoted": "Tekliflendi",
  "rfq.list.filter.nocustomer": "Müşterisiz",
  "rfq.list.customerFilters": "Müşteriye göre süz",
  "rfq.list.assign": "Müşteri ata",
  "rfq.list.assignName": "Müşteri adı",
  "rfq.list.assignEmail": "E-posta",
  "rfq.list.assignSave": "Ata",
  "rfq.list.assignEmpty": "Kayıtlı müşteri yok. Ad ve e-posta girin.",
  "rfq.list.assignHint": "E-posta, bu RFQ'yu Müşteriler altında listeler.",
  "rfq.list.col.number": "RFQ",
  "rfq.list.col.customer": "Müşteri",
  "rfq.list.col.email": "E-posta",
  "rfq.list.col.parts": "Parçalar",
  "rfq.list.col.status": "Durum",
  "rfq.list.col.received": "Geliş tarihi",
  "rfq.list.col.activity": "Son hareket",
  "rfq.list.col.due": "Termin",
  "rfq.list.col.quote": "Teklif",
  "rfq.list.col.assignee": "Sorumlu",
  "rfq.list.assigneeLocked": "Sorumlu kaydedilemiyor. Motor PATCH /v1/rfqs/{id} üzerinde sorumlu alanı ve çalışma alanı üye listesi sunmuyor.",
  "rfq.list.step.uploaded": "Yüklendi",
  "rfq.list.step.bom": "BOM",
  "rfq.list.step.costed": "Maliyetlendi",
  "rfq.list.step.quoted": "Tekliflendi",
  "rfq.list.empty": "Henüz RFQ yok.",
  "rfq.list.noMatch": "Bu filtreye uyan RFQ yok.",
  "rfq.list.open": "RFQ'yu aç",
  "rfq.list.pdf": "Teklif PDF",
  "rfq.list.delete": "Sil",
  "rfq.list.selectAll": "Tüm RFQ'ları seç",
  "rfq.list.selectOne": "{no} seç",
  "rfq.list.bulkTitle": "{count} RFQ silinsin mi?",
  "rfq.list.bulkTitleOne": "1 RFQ silinsin mi?",
  "rfq.list.bulkBody": "Bu işlem geri alınamaz.",
  "rfq.list.cancel": "Vazgeç",
  "rfq.list.deleting": "Siliniyor…",
  "rfq.list.actions": "{no} işlemleri",
  "rfq.list.attention": "İlgilenilmeli",
  "rfq.list.sortNumber": "RFQ numarasına göre sırala",
  "rfq.list.sortReceived": "Geliş tarihine göre sırala",
  "rfq.list.uploading": "Yükleniyor",
  "rfq.list.uploaded": "Yüklendi",
  "rfq.list.processing": "İşleniyor",
  "rfq.list.confirmDelete": "{no} silinsin mi?",
  "rfq.list.pdfDemo": "Demoda teklif PDF'i yok.",
  "rfq.list.moreParts": "+{n}",
  "rfq.list.domainHint": "E-posta alan adı",
  "rfq.list.overdue": "Gecikmiş",
  "rfq.list.mark.costed": "Maliyetlendi",
  "rfq.list.mark.decided": "Karar verildi",
  "rfq.list.mark.unreadable": "Dosya okunamadı",
  "rfq.list.mark.skipped": "Satır atlandı",
  "rfq.list.mark.okLegend": "Maliyetlendi veya karar verildi",
  "rfq.list.mark.badLegend": "Okunamadı veya atlandı",
  "rfq.list.tab.action": "İşlem gerekli",
  "rfq.list.tab.approval": "Onay bekliyor",
  "rfq.list.tab.closed": "Kapandı",
  "rfq.list.filterButton": "Süz",
  "rfq.list.filter.date": "Tarih",
  "rfq.list.filter.last30": "Son 30 gün",
  "rfq.list.filter.clear": "Temizle",
  "rfq.list.filter.removeDate": "Tarih süzgecini kaldır",
  "rfq.list.filtersMenu": "Süzgeçler",
  "rfq.list.col.job": "İş",
  "rfq.list.col.company": "Firma",
  "rfq.list.col.stage": "Aşama",
  "rfq.list.col.amount": "Tutar",
  "rfq.list.col.uploadedBy": "Yükleyen",
  "rfq.list.col.updated": "Güncellendi",
  "rfq.list.sortUpdated": "Güncellemeye göre sırala",
  "rfq.list.menu.documents": "Belgeleri göster",
  "rfq.list.menu.archive": "Arşivle",
  "rfq.list.archiveUnavailable": "Arşiv kaydedilemiyor. RFQ kaydında arşiv alanı yok.",
  "rfq.list.export": "Dışa aktar",
  "rfq.list.selected": "{count} RFQ seçildi",
  "rfq.list.selectedOne": "1 RFQ seçildi",
  "rfq.list.clearSelection": "Seçimi kaldır",
  "rfq.list.range": "{from}–{to} / {total}",
  "rfq.list.prev": "Önceki",
  "rfq.list.next": "Sonraki",
  "rfq.list.stage.stock": "Stok eksik ({n} kalem)",
  "rfq.list.stage.check": "Kontrol gerekli",
  "rfq.list.stage.quoteReady": "Teklif hazır",
  "rfq.list.stage.parameters": "Parametreler girildi",
  "rfq.list.updated.today": "Bugün",
  "rfq.list.updated.yesterday": "Dün",
  "rfq.list.updated.days": "{n} gün",
  "rfq.list.preview.lastCost": "Son maliyet {amount}",
  "rfq.list.preview.usedIn": "{n} RFQ'da kullanıldı",
  "rfq.list.preview.usedInOne": "1 RFQ'da kullanıldı",
  "rfq.list.preview.openDocs": "Belgelerde aç",
  "rfq.list.uploadedByMissing": "Bu RFQ'da yükleyen yok",
  "rfq.empty": "Henüz RFQ yok. Bir tane oluşturun, sonra katalogdan parça/BOM ekleyin veya CAD yükleyin.",
  "rfq.untitled": "Başlıksız",
  "rfq.col.no": "No",
  "rfq.col.title": "Başlık",
  "rfq.col.lines": "Satır",
  "rfq.col.hours": "Saat",
  "rfq.pendingShort": "{n} bekliyor",
  "rfq.status.draft": "Taslak",
  "rfq.status.estimating": "Hesaplanıyor",
  "rfq.status.waiting": "Müşteri bekleniyor",
  "rfq.status.ready": "Hazır",
  "rfq.status.sent": "Gönderildi",
  "rfq.status.cancelled": "İptal",
  "rfq.status.won": "Kazanıldı",
  "rfq.status.produced": "Üretildi",
  "rfq.status.lost": "Kaybedildi",
  "rfq.outcome.won": "Kazanıldı işaretle",
  "rfq.outcome.lost": "Kaybedildi işaretle",
  "rfq.reason.label": "Kayıp nedeni",
  "rfq.reason.none": "Neden yok",
  "rfq.reason.price": "Fiyat",
  "rfq.reason.lead": "Termin",
  "rfq.reason.capacity": "Kapasite",
  "rfq.reason.no_bid": "Teklif yok",
  "rfq.winRate": "Kazanma {pct}",
  "rfq.winRateEmpty": "Kazanma —",
  "rfq.err.outcome": "Yalnızca gönderilmiş teklif kazanıldı veya kaybedildi işaretlenebilir.",
  "rfq.send": "Gönderildi işaretle",
  "rfq.sendMail": "Teklif maili gönder",
  "rfq.sendQuestion": "Soru maili gönder",
  "rfq.sendConfirm": "Gönder",
  "rfq.mailTo": "Kime",
  "rfq.convertOrder": "Siparişe dönüştür",
  "rfq.linkedSo": "Satış siparişi {so}",
  "rfq.sentAt": "Gönderildi {when}",
  "rfq.pdf": "Teklif PDF indir",
  "rfq.quote.oneItem": "{n} kalem",
  "rfq.quote.manyItems": "{n} kalem",
  "rfq.err.margin": "Bu teklif gönderilmeden önce marjı onaylayın.",
  "rfq.back": "Tüm RFQ’lar",
  "rfq.leadDays": "{n} g teslim",
  "rfq.addCatalog": "Katalogdan",
  "rfq.pickLine": "Rota ve süre için bir satır seçin.",
  "rfq.makeBuyLabel": "Yap / al",
  "rfq.makeBuy.undecided": "Kararsız",
  "rfq.makeBuy.make": "İmalat",
  "rfq.makeBuy.buy": "Satın al",
  "rfq.makeBuy.outsource": "Dışarı",
  "rfq.makeBuy.mixed": "Karışık",
  "rfq.buyKeepsRoute": "Satın al freze operasyonunu silmez — süreler satırda kalır.",
  "rfq.outsourceKeepsRoute": "Dışarı iş, rotayı taşeron tahmini olarak tutar.",
  "rfq.supplier.title": "Tedarikçi RFQ",
  "rfq.supplier.hint": "Son alış: {price} · {days} g (bağlayıcı değil)",
  "rfq.supplier.hintPrice": "Son alış: {price} (bağlayıcı değil)",
  "rfq.supplier.hintEmpty": "Kayıtlı son alış yok",
  "rfq.supplier.waiting": "Tedarikçi bekleniyor",
  "rfq.supplier.answered": "Tedarikçi cevapladı",
  "rfq.supplier.unitPrice": "Birim fiyat (TRY)",
  "rfq.supplier.lead": "Teslim gün",
  "rfq.supplier.reply": "Tedarikçi teklifini kaydet",
  "rfq.supplier.copy": "Tedarikçi mailini kopyala",
  "rfq.supplier.mailTitle": "Tedarikçi maili (gönderilmez)",
  "rfq.seedIntel": "Üretim intel’den doldur",
  "rfq.seedOverwriteTitle": "Operasyonlar değiştirilsin mi?",
  "rfq.seedOverwriteBody": "Bu satırda zaten operasyon var. Üretim intel ile üzerine yazın, eksikleri birleştirin veya geometriden tahmini yeniden çalıştırın.",
  "rfq.seedOverwriteBtn": "Üzerine yaz",
  "rfq.seedMergeBtn": "Birleştir",
  "rfq.seedRefreshBtn": "Tahmini yenile",
  "rfq.cancel": "Vazgeç",
  "rfq.intel.meta": "{provider} · %{pct} güven",
  "rfq.op": "Op",
  "rfq.setup": "Hazırlık s",
  "rfq.run": "Çevrim s/adet",
  "rfq.machine": "Tezgah",
  "rfq.addOp": "Operasyon ekle",
  "rfq.deleteLine": "Satırı sil",
  "rfq.noViewer": "Bu satırda henüz CAD yok.",
  "rfq.viewerFailed": "Çizim yüklenemedi.",
  "rfq.viewer.open": "3D'de aç",
  "rfq.viewer.close": "3D görüntüleyiciyi kapat",
  "rfq.viewer.closeLabel": "Kapat",
  "rfq.viewer.panel": "3D görüntüleyici",
  "rfq.noDesc": "Açıklama yok",
  "rfq.decision.pending": "Bekliyor",
  "rfq.decision.decided": "Kararlı",
  "rfq.decision.skipped": "Atlandı",
  "rfq.pickerTitle": "Katalogdan ekle",
  "rfq.uploadFailed": "Yükleme dosya döndürmedi.",
  "rfq.err.generic": "RFQ güncellenemedi.",
  "rfq.err.noIntel": "Bu parça için üretim intel’i yok. Önce çizimi parse edin veya tahmini yenileyin.",
  "rfq.err.noJob": "Bu satırın kaynak çizimi yok.",
  "rfq.err.triage": "Teklif hazır değil. Eksik veya belirsiz alan var.",
  "rfq.err.audit": "Teklifte iç çelişki var.",
  "rfq.err.invalidQtys": "Bu adetler geçersiz.",
  "rfq.whatif": "Adet",
  "rfq.whatif.qty": "{n} adet",
  "rfq.whatif.cost": "Maliyet",
  "rfq.whatif.lead": "Termin",
  "rfq.due": "Teslim",
  "rfq.check": "Teklif kontrolü",
  "rfq.triage.open": "Teklif verilebilir mi?",
  "rfq.triage.rerun": "Kontrolü yenile",
  "rfq.triage.loading": "Kontrol ediliyor…",
  "rfq.triage.bannerTitle": "Bu RFQ için henüz teklif veremeyiz",
  "rfq.triage.bannerBody": "Engelleyici noktalar: {blockers}. Uyarılar: {warnings}.",
  "rfq.triage.bannerReady": "Bu RFQ için teklif verilebilir.",
  "rfq.triage.points": "Eksik ve riskli noktalar",
  "rfq.triage.foundBy": "Teklif kontrolü buldu",
  "rfq.triage.blocking": "Engelliyor",
  "rfq.triage.risk": "Risk",
  "rfq.triage.added": "E-postaya eklendi",
  "rfq.triage.questions": "Müşteriye sorular",
  "rfq.triage.draft": "Ajan taslağı",
  "rfq.triage.langTr": "E-posta dili: Türkçe",
  "rfq.triage.to": "Kime",
  "rfq.triage.subject": "Konu",
  "rfq.triage.copy": "Metni kopyala",
  "rfq.triage.copied": "Kopyalandı",
  "rfq.triage.mailto": "Posta uygulamasında aç",
  "rfq.triage.markSent": "Gönderildi işaretle → Müşteri bekleniyor",
  "rfq.triage.status": "RFQ durumu",
  "rfq.triage.waitingSince": "{when} tarihinden beri bekleniyor",
  "rfq.triage.waitingReply": "Cevap bekleniyor",
  "rfq.triage.waitingNote": "Tahmin duraklatıldı; müşteriye otomatik bir şey gönderilmez.",
  "rfq.triage.replies": "Kayıtlı cevaplar",
  "rfq.triage.pasteTitle": "Müşteri cevabını yapıştırın",
  "rfq.triage.pasteHelp": "E-posta metnini yapıştırın. Cevap kaydedilir. Adet, termin ve malzeme yalnızca metin onları belirtiyorsa dolar, sonra kontrol yeniden çalışır.",
  "rfq.triage.apply": "Cevapları uygula",
  "rfq.triage.pastePh": "Cevabı buraya yapıştırın",
  "rfq.triage.attach": "Yeni çizim ekle",
  "rfq.triage.applyNote": "Tüm engelleyici noktalar kapandığında durum Tahmin’e döner.",
  "rfq.triage.canWe": "Teklif verilebilir mi?",
  "rfq.triage.linesReady": "Maliyete hazır kalemler",
  "rfq.triage.linesReadyValue": "{ready} / {total}",
  "rfq.triage.blockingCount": "Engelleyici noktalar",
  "rfq.triage.warningCount": "Uyarılar",
  "rfq.triage.items": "{n} kalem",
  "rfq.triage.item": "1 kalem",
  "rfq.triage.files": "{n} dosya",
  "rfq.triage.receivedToday": "bugün {time} alındı",
  "rfq.triage.received": "{when} alındı",
  "rfq.triage.unavailable": "Teklif kontrolü kullanılamıyor.",
  "rfq.triage.waitClear": "Beklenecek bir eksik yok. Teklif kontrolü temiz.",
  "rfq.triage.quoteMail": "Teklif e-postası",
  "rfq.triage.empty": "Açık nokta yok.",
  "rfq.markReady": "Hazır işaretle",
  "rfq.wait": "Müşteri bekleniyor",
  "rfq.reply.label": "Müşteri cevabı",
  "rfq.reply.ph": "Müşteri cevabını yapıştırın…",
  "rfq.reply.submit": "Cevabı kaydet",
  "rfq.margin.suggested": "Önerilen marj",
  "rfq.margin.approved": "Onaylı marj %",
  "rfq.margin.total": "Teklif toplamı",
  "rfq.copyMail": "Soru mailini kopyala",
  "rfq.copied": "Kopyalandı",
  "rfq.mailTitle": "Soru maili (gönderilmez)",
  "rfq.quoteReady": "Teklife hazır",
  "rfq.quoteNotReady": "Teklife hazır değil",
  "rfq.findings": "Açık sorular",
  "rfq.auditTitle": "Teklif denetimi",
  "rfq.geo.uncertain": "Geometri yöntemleri çelişiyor",
  "rfq.geo.winner": "Geometri: {source}",
  "rfq.geo.unread": "Okunmamış çizim notu",
  "rfq.sub.title": "Malzeme ikamesi",
  "rfq.sub.ask": "Müşteri onayı gerekir",
  "rfq.sub.ok": "Aynı sınıf ikame",
  "rfq.mailSubject": "Konu",
  "quote.locked": "Teklif kilitli",
  "quote.download": "Teklif indir",
  "quote.hitl": "Teklif · satır onayla",
  "quote.partial": "Teklif · eksik dosya",
  "quote.parse": "Teklif · parse gerekli",
  "quote.geometry": "Teklif · geometri belirsiz",
  "quote.substitute": "Teklif · ikame onayı",
  "quote.noBid": "Teklif · no bid",
  "rfq.similar": "{n} benzer iş, ortalama {actual} s (o zaman {est} s tahmin)",
  "rfq.similarCost": "{actual} (o zaman {est} tahmin)",
  "rfq.similarEmpty": "Henüz benzer kapanmış iş yok",
  "rfq.similarOpen": "{no} teklifini aç",
  "rfq.similarHours": "{actual} gerçek · {est} tahmin",
  "rfq.similarEstOnly": "{est} tahmin",
  "rfq.similarActualOnly": "{actual} gerçek",
  "rfq.similarClosed": "Kapanış {when}",
  "rfq.similarWon": "Kazanılmış kapanış",
  "rfq.similarOver": "tahminden {h} fazla",
  "rfq.similarUnder": "tahminden {h} az",
  "rfq.similarOnEst": "tahminle aynı",
  "rfq.err.intake": "RFQ paketi okunamadı.",
  "rfq.intake.title": "Karışık giriş",
  "rfq.intake.hint": "E-postayı yapıştırın, CAD / Excel / diğer ekleri bırakın. Okunmayan ekler bağlı kalır, parse edilmez.",
  "rfq.intake.drop": "CAD, Excel, PDF veya görsel bırakın",
  "rfq.intake.mail": "E-posta gövdesi",
  "rfq.intake.mailPh": "Müşteri e-postasını yapıştırın…",
  "rfq.intake.submit": "Talebi çıkar",
  "rfq.intake.read": "Okundu",
  "rfq.intake.unread": "Okunmadı",
  "rfq.intake.failed": "Hata",
  "rfq.intake.pending": "Bekliyor",
  "rfq.intake.qtyUnknown": "adet yok",
  "rfq.intake.remove": "Kaldır",
  "rfq.err.shortage": "Bu teklifi siparişe çevirmek için stok yetersiz.",
  "rfq.err.quoteLocked": "Bu teklif kilitli.",
  "rfq.err.useMailSend": "Teklif mailini inceleme penceresinden gönderin.",
  "rfq.quoteMailTitle": "Teklif maili",
  "rfq.inbox": "Gelen kutusu",
  "rfq.inboxEmpty": "Gelen mail yok.",
  "rfq.inboxDisabled": "Mail alma kapalı.",
  "rfq.mailApply": "RFQ’ya uygula",
  "rfq.mailLink": "Bu RFQ’ya bağla",
  "rfq.mailRead": "Okundu işaretle",
  "rfq.mailRetry": "Yeniden gönder",
  "rfq.supplier.send": "Tedarikçi maili gönder",
  "rfq.supplier.email": "Tedarikçi e-posta",
  "rfq.deleteConfirmTitle": "Bu satır silinsin mi?",
  "rfq.deleteConfirmBody": "Satır tekliften kaldırılacak.",

  "mail.delivery.queued": "Kuyrukta",
  "mail.delivery.sending": "Gönderiliyor",
  "mail.delivery.sent": "Gönderildi",
  "mail.delivery.failed": "Başarısız",
  "mail.delivery.unknown": "Bilinmiyor",
  "mail.unmatched": "Eşleşmedi",
  "mail.matched": "Eşleşti",

  "erp.title": "SemantiCAD ERP",
  "erp.subtitle": "Atölyenin kendi kayıt sistemi — stok kartı, hareket, satın alma ve iş emri",
  "erp.refresh": "Yenile",
  "erp.nav.aria": "ERP bölümleri",
  "erp.nav.overview": "Özet",
  "erp.nav.stock": "Stok",
  "erp.nav.movements": "Hareketler",
  "erp.nav.po": "Satın alma",
  "erp.nav.wo": "İş emirleri",
  "erp.nav.so": "Satış siparişleri",
  "erp.nav.dn": "Sevkiyat",
  "erp.kpi.sku": "Kalem",
  "erp.kpi.critical": "Min altı",
  "erp.kpi.openPo": "Açık SA",
  "erp.kpi.openWo": "Açık İE",
  "erp.kpi.movToday": "Bugün hareket",
  "erp.activity": "Son hareketler",
  "erp.activityEmpty": "Henüz kayıt yok. Stok ekleyin veya incelemeden sonra işi ERP’ye işleyin.",
  "erp.stockEmpty": "Stok kartı boş. İlk kalemi ekleyin veya CSV içe aktarın.",
  "erp.cat.all": "Tümü",
  "erp.cat.sabitler": "Sabitler",
  "erp.cat.islenebilir": "İşlenebilir",
  "erp.cat.hurda_talas": "Hurda / talaş",
  "erp.cat.modullesmis": "Modülleşmiş",
  "erp.col.category": "Kategori",
  "erp.col.itemClass": "Sınıf / tip",
  "erp.col.itemClassPh": "ör. bağlantı elemanı, yedek, hammadde…",
  "erp.stock.add": "Stok ekle",
  "erp.stock.addFirst": "İlk kalemi ekle",
  "erp.stock.importCsv": "CSV içe aktar",
  "erp.stock.pull": "Dış stoğu çek",
  "erp.stock.pullTitle": "Dış miktar uyuşmazlıkları",
  "erp.stock.pullOk": "Dış stok yerel eldeki ile uyumlu ({n} SKU).",
  "erp.stock.pullConflicts": "{n} SKU dış stoktan farklı.",
  "erp.stock.search": "Parça, malzeme, lokasyon ara…",
  "erp.stock.formCreate": "Yeni stok kartı",
  "erp.stock.formEdit": "Stok kartını düzenle",
  "erp.stock.save": "Kaydet",
  "erp.stock.edit": "Düzenle",
  "erp.stock.qtyHint": "Miktar değişimi defter için “Düzelt” (giriş/çıkış) ile yapılır.",
  "erp.stock.created": "Stok eklendi: {part}",
  "erp.stock.updated": "Stok güncellendi: {part}",
  "erp.stock.imported": "{n} stok satırı içe aktarıldı (katalog yenilendi)",
  "erp.stock.noMatch": "Aramaya uyan satır yok.",
  "erp.stock.cadTitle": "CAD / dosya",
  "erp.stock.cadSabitHint": "Sabit parçalar için STEP geometrisi ekleyin",
  "erp.stock.cadEmpty": "Henüz dosya yok — PDF, görsel veya CAD (STEP/DXF)",
  "erp.stock.cadUpload": "Dosya yükle",
  "erp.stock.cadDownload": "İndir",
  "erp.stock.cadRemove": "Kaldır",
  "erp.stock.cadAfterSave": "Önce stok kartını kaydedin, sonra STEP/CAD ekleyin.",
  "erp.stock.cadTypes": "İzin: .step .stp .dxf .dwg .pdf .png .jpg .webp",
  "erp.stock.cadOk": "Dosya eklendi: {name}",
  "erp.stock.cadCleared": "Dosya stok kartından kaldırıldı",
  "erp.comp.title": "İçerik (modül BOM)",
  "erp.comp.modulHint": "Bu modülün içindeki sabitler ve işlenebilir malzemeler",
  "erp.comp.anyHint": "İsteğe bağlı: bu karta bağlı alt stok kalemleri",
  "erp.comp.emptyGroup": "Henüz yok",
  "erp.comp.needQty": "Modül başına miktar",
  "erp.comp.remove": "Çıkar",
  "erp.comp.other": "Diğer",
  "erp.comp.pickChild": "Sabit / işlenebilir seç…",
  "erp.comp.add": "Modüle ekle",
  "erp.comp.added": "Bileşen modül BOM’una eklendi",
  "erp.comp.errChild": "Alt stok kalemi seçin",
  "erp.movEmpty": "Hareket yok.",
  "erp.poEmpty": "Satın alma emri yok. \"PO oluştur\" ile elle açın ya da HITL sonrası BUY aksiyonlu işi ERP'ye işleyin.",
  "erp.woEmpty": "İş emri yok. HITL sonrası MAKE aksiyonlu iş commit edin.",
  "erp.soEmpty": "Satış siparişi yok. Kazanılan RFQ’yu dönüştürün.",
  "erp.dnEmpty": "İrsaliye yok.",
  "erp.so.cancel": "Siparişi iptal et",
  "erp.dn.draft": "Taslak irsaliye oluştur",
  "erp.dn.pdf": "PDF",
  "erp.dn.ship": "Sevk et ve stok düş",
  "erp.dn.shipConfirm": "Sevkiyatı ve stok düşümünü onayla",
  "erp.dn.cancel": "Taslağı iptal et",
  "erp.dn.address": "Alıcı adresi",
  "erp.dn.method": "Sevkiyat yöntemi",
  "erp.dn.noOrders": "Sevk edilecek satış siparişi yok.",
  "erp.dn.review": "Sevkiyatı incele",
  "erp.dn.lines": "Düşülecek satırlar",
  "erp.status.confirmed": "Onaylı",
  "erp.status.partial": "Kısmi",
  "erp.status.delivered": "Teslim",
  "erp.status.cancelled": "İptal",
  "erp.status.draft": "Taslak",
  "erp.status.shipped": "Sevk edildi",
  "erp.status.unknown": "Bilinmiyor",
  "erp.so.confirmCancel": "Bu satış siparişi iptal edilsin mi?",
  "erp.so.confirmCancelBody": "Aktif rezervasyonlar serbest bırakılır. Taslak iş emirleri ve irsaliyeler iptal edilir.",
  "erp.dn.confirmCancel": "Bu taslak irsaliye iptal edilsin mi?",
  "erp.dn.confirmCancelBody": "Taslak silinir. Stok düşülmez.",
  "erp.err.salesDisabled": "Bu atölyede satış siparişleri açık değil.",
  "erp.salesDisabled": "Satış siparişleri kapalı.",
  "erp.confirm.continue": "Onayla",
  "erp.col.customer": "Müşteri",
  "erp.col.total": "Toplam ₺",
  "erp.col.part": "Parça",
  "erp.col.desc": "Açıklama",
  "erp.col.material": "Malzeme",
  "erp.col.unit": "Birim",
  "erp.col.onHand": "Eldeki",
  "erp.col.externalQty": "Dış miktar",
  "erp.col.delta": "Fark",
  "erp.col.reserved": "Rezerve",
  "erp.col.available": "Kullanılabilir",
  "erp.col.min": "Min",
  "erp.col.max": "Max",
  "erp.col.price": "Fiyat ₺",
  "erp.col.lead": "Tedarik gün",
  "erp.col.location": "Lokasyon",
  "erp.col.supplier": "Tedarikçi",
  "erp.col.kind": "Tür",
  "erp.col.qty": "Miktar",
  "erp.col.balance": "Bakiye",
  "erp.col.ref": "Ref",
  "erp.col.actions": "İşlem",
  "erp.col.docNo": "Belge",
  "erp.col.status": "Durum",
  "erp.col.lines": "Satırlar",
  "erp.adjust": "Düzelt",
  "erp.adjustTitle": "Düzelt #{id}",
  "erp.kind.receive": "Giriş",
  "erp.kind.issue": "Çıkış",
  "erp.apply": "Uygula",
  "erp.total": "Toplam",
  "erp.po.submit": "Gönder",
  "erp.po.create": "PO oluştur",
  "erp.po.formTitle": "Yeni satın alma emri",
  "erp.po.hint": "Çizimden bağımsız alım için elle PO açabilirsiniz.",
  "erp.po.addLine": "Satır ekle",
  "erp.po.removeLine": "Satırı sil",
  "erp.po.notes": "Not",
  "erp.po.save": "Kaydet",
  "erp.po.created": "{no} oluşturuldu.",
  "erp.po.errLines": "En az bir satırda parça no ve 0'dan büyük miktar gerekli.",
  "erp.po.receive": "Mal kabul",
  "erp.wo.release": "Serbest bırak",
  "erp.wo.complete": "Tamamla",

  // ERP v2-1 — atölye terminali, makineler, tahmin doğruluğu
  "erp.nav.terminal": "Saat girişi",
  "erp.nav.machines": "Makineler",
  "erp.nav.accuracy": "Tahmin doğruluğu",
  "erp.sf.disabled": "Atölye takibi kapalı. Engine'de şu ayarı açın:",
  "erp.sf.noWo": "Açık iş emri yok. Önce bir iş emri açın.",
  "erp.sf.noOps": "Bu iş emrinde operasyon yok. Rota tanımlayın.",
  "erp.sf.good": "Sağlam",
  "erp.sf.scrap": "Fire",
  "erp.sf.est": "Tahmini",
  "erp.sf.recorded": "Kayıtlı",
  "erp.sf.hoursLabel": "Süre (saat)",
  "erp.sf.save": "Kaydet",
  "erp.sf.addMore": "Süre ekle",
  "erp.sf.entrySaved": "Süre kaydedildi.",
  "erp.sf.errHours": "Süre 0'dan büyük olmalı.",
  "erp.sf.noMachine": "Makine atanmadı",
  "erp.sf.status.pending": "Bekliyor",
  "erp.sf.status.running": "Çalışıyor",
  "erp.sf.status.done": "Bitti",
  "erp.sf.status.skipped": "Atlandı",
  "erp.sf.cost.material": "Malzeme",
  "erp.sf.cost.labor": "İşçilik",
  "erp.sf.cost.total": "Toplam",
  "erp.sf.cost.perUnit": "Sağlam adet başı",
  "erp.sf.cost.hoursVar": "Saat sapması",
  "erp.sf.cost.scrapRate": "Fire oranı",
  "erp.sf.close": "İşi kapat",
  "erp.sf.closed": "İş emri kapatıldı, gerçek maliyet yazıldı.",
  "erp.machines.hint": "Saat ücreti, kaydedilen saatleri paraya çeviren şeydir.",
  "erp.machines.add": "Makine ekle",
  "erp.machines.empty": "Makine tanımlı değil. Gerçek maliyet için en az bir makine ekleyin.",
  "erp.machines.code": "Kod",
  "erp.machines.name": "Ad",
  "erp.machines.kind": "Tür",
  "erp.machines.rate": "Saat ücreti",
  "erp.machines.capacity": "Günlük kapasite",
  "erp.machines.save": "Kaydet",
  "erp.machines.noRate": "ücret girilmedi",
  "erp.machines.errCode": "Makine kodu zorunlu.",
  "erp.machines.created": "{code} eklendi.",
  "erp.acc.hint":
    "Bitmiş operasyonlarda tahmin edilen saat ile gerçekleşen saati karşılaştırır. Oran 1'in üstündeyse o prosesi sürekli az tahmin ediyoruz.",
  "erp.acc.empty": "Henüz bitmiş operasyon yok. Terminalde iş kaydı biriktikçe dolar.",
  "erp.acc.opCode": "Proses",
  "erp.acc.count": "Operasyon",
  "erp.acc.est": "Tahmini",
  "erp.acc.actual": "Gerçek",
  "erp.acc.variance": "Sapma",
  "erp.acc.ratio": "Oran",
  "erp.acc.scrapRate": "Fire",
  "erp.acc.underQuoted": "az tahmin",
  "erp.acc.overQuoted": "fazla tahmin",
  "erp.err.db": "ERP için Postgres gerekir (DATABASE_URL). Stack’i açıp migrate edin.",
  "erp.err.disabled": "Engine’de ERP kapalı (SEMANTICAD_ERP_V1).",
  "erp.err.pullNotConfigured":
    "Dış ERP çekimi yapılandırılmamış. SEMANTICAD_ERP_PULL_URL verin veya SEMANTICAD_ERP_PULL_ADAPTER=sim kullanın.",
  "erp.err.pullFailed": "Dış ERP çekimi başarısız.",
  "erp.err.generic": "ERP isteği başarısız",
  "erp.err.qty": "Pozitif miktar girin",
  "erp.err.partRequired": "Stok kodu zorunlu",
  "erp.commit": "ERP’ye işle",
  "erp.commitBusy": "İşleniyor…",
  "erp.commitOk": "ERP belgeleri oluşturuldu",
  "erp.commitBlocked": "ERP’ye işlemek için önce HITL onaylayın",

  "status.online": "Bağlı",
  "status.offline": "Bağlantı yok",
  "status.queue": "Kuyruk: {count}",
  "status.language": "Dil",
  "status.lang.en": "English",
  "status.lang.tr": "Türkçe",

  "welcome.subtitle": "CAD dosyanızı açın ve üretim analizine başlayın",
  "welcome.dashboardSub": "Atölye özeti — geçmiş işler, toplamlar ve yeni dosya",
  "welcome.dropLabel": "Dosya sürükleyin veya seçin",
  "welcome.formats": "DXF · STEP · DWG",
  "welcome.openFile": "Dosya Aç",
  "welcome.loadDemo": "Demo montajı yükle",
  "welcome.loadingDemo": "Demo montaj yükleniyor…",
  "welcome.demoHint": "SLICRANK MECHANISM — çevrimdışı BOM + rapor + mesh",
  "welcome.recent": "Son çizimler",
  "welcome.history": "İş geçmişi",
  "welcome.historyLoading": "Geçmiş yükleniyor…",
  "welcome.historyEmpty": "Henüz iş yok. CAD dosyası açın veya demo yükleyin.",
  "welcome.historyError": "Sunucu geçmişi alınamadı. Yerel önbellek varsa o gösterilir.",
  "welcome.refresh": "Yenile",
  "welcome.newWork": "Yeni iş",
  "welcome.openHint": "DXF, STEP veya DWG. Çoklu dosyada ana montaj seçilir.",
  "welcome.kpiAria": "Atölye KPI",
  "welcome.kpi.jobs": "İşler",
  "welcome.kpi.jobsHint": "toplam geçmiş",
  "welcome.kpi.ready": "Hazır",
  "welcome.kpi.readyHint": "parse tamam",
  "welcome.kpi.open": "Devam eden",
  "welcome.kpi.openHint": "parse / onay",
  "welcome.kpi.parts": "Parça",
  "welcome.kpi.partsHint": "BOM satırı",
  "welcome.kpi.material": "Malzeme ₺",
  "welcome.kpi.materialHint": "oturum tahmini",
  "welcome.col.file": "Dosya",
  "welcome.col.status": "Durum",
  "welcome.col.parts": "Parça",
  "welcome.col.when": "Güncelleme",

  "tab.viewer": "Görünüm",
  "tab.bom": "BOM",
  "tab.reports": "Üretim Raporu",
  "tab.viewerShort": "Görüntüleyici",
  "tab.viewerOpen": "3B/2B görüntüleyiciyi yan panelde aç",
  "tab.viewerClose": "Görüntüleyiciyi gizle",
  "tab.reportsShort": "Raporlar",
  "tab.review": "İnceleme",

  "mode.parts": "Parçalar",
  "mode.review": "Onay",
  "mode.quote": "Teklif",
  "mode.preview": "Önizleme",
  "mode.previewHint": "sadece referans",
  "split.resize": "Önizleme ve çalışma panellerini yeniden boyutlandır",
  "mode.aria": "İş adımları",
  "mode.jobSteps": "İş adımları: Parçalar, Onay, Teklif",
  "mode.geometry": "Parçalar",
  "mode.production": "Teklif",

  "parse.queued": "Kuyrukta…",
  "parse.processing": "İşleniyor…",
  "parse.analyzing": "Analiz ediliyor…",
  "parse.loadingHistory": "Önceki çizim yükleniyor…",
  "parse.error": "Parse hatası",
  "parse.pack": "İş paketi parse ediliyor…",
  "parse.packMaster": "İş paketi: master parse… (+{n} uydu)",
  "parse.retry": "Yeniden parse…",
  "parse.quotePreparing": "Teklif PDF hazırlanıyor…",
  "parse.partialFailed":
    "Kısmi parse: {n} uydu dosya başarısız. Teklif onay/düzeltme sonrası açılır.",
  "parse.softCap": "Çok solid ({n}) — liste sadeleştirildi",
  "parse.quoteReady": "Teklif üretildi:\n{detail}",
  "parse.drawingPreparing": "Üretim çizimi PDF hazırlanıyor…",
  "parse.drawingReady": "Üretim çizimi hazır:\n{detail}",

  "drawing.assembly": "Montaj çizimi",
  "drawing.assemblyHint": "Tüm modelin çok görünüşlü PDF’i (şekil + veri — teklif değil)",
  "drawing.part": "Parça çizimi",
  "drawing.partCol": "Çizim",
  "drawing.partHint": "Bu BOM solid’i için çok görünüşlü PDF",
  "drawing.exporting": "Çizim…",
  "drawing.started": "Üretim çizimi indirmesi başladı…",
  "drawing.ok": "Üretim çizimi indirildi",
  "drawing.fail": "Çizim dışa aktarma başarısız",

  "tabbar.empty": "Dosya açın veya STEP/DXF sürükleyin",
  "tabbar.close": "Sekmeyi kapat",
  "tabbar.openBom": "BOM",
  "tabbar.openReport": "Rapor",
  "tabbar.openReview": "İnceleme",

  "hitl.banner.blocked": "Teklif kilitli · {count} onay",
  "hitl.banner.ready": "Teklif açıldı",
  "hitl.banner.noJob": "HITL incelemek için iş açın veya parse edin",
  "hitl.approve": "Onayla",
  "hitl.approveAll": "Tümünü onayla",
  "hitl.empty": "Onay bekleyen satır yok",
  "hitl.openCount": "{count} açık",
  "hitl.reasons.low_confidence": "Düşük güven",
  "hitl.detail.reasons": "Nedenler",
  "hitl.detail.confidence": "Güven",
  "hitl.detail.none": "Bir satır seçin",
  "hitl.detail.material": "Malzeme",
  "hitl.detail.qty": "Adet",
  "hitl.detail.reason": "Gerekçe",
  "hitl.reasonPlaceholder": "Neden reddediliyor veya no-bid?",
  "hitl.reject": "Reddet",
  "hitl.noBid": "No bid",
  "hitl.reasonRequired": "Gerekçe zorunlu",
  "hitl.invalidQty": "Adet 0'dan büyük olmalı",
  "hitl.lowConf.title": "Düşük güvenli ölçüler",
  "report.kpi.meta.volumeHoles": "{vol} · {n} delik",
  "report.kpi.meta.volumeOcc": "katı hacim",
  "report.kpi.meta.volumeProxy": "proxy hacim",
  "report.kpi.meta.holesOnly": "{n} delik",

  "panel.explorer": "Gezgin",
  "panel.select": "Seçim",
  "panel.measure": "Ölçüm",
  "panel.bom": "BOM",
  "panel.reports": "Raporlar",
  "panel.selectPart": "Parçayı seç / vurgula",
  "panel.days": "{n} gün",
  "panel.openTabs": "Açık sekmeler",
  "panel.drawings": "Çizimler",
  "panel.noDrawings": "Açık çizim yok",
  "panel.openDrawingFirst": "Önce bir çizim açın.",
  "panel.noSelection": "Seçim yok",
  "panel.coord": "koordinat",
  "panel.noActiveDrawing": "Aktif çizim yok.",
  "panel.noBom": "BOM verisi yok.",
  "panel.openBomTab": "BOM sekmesini aç",
  "panel.fullBom": "Tam BOM görünümü",
  "panel.itemCount": "{n} kalem",
  "panel.production": "Üretim",
  "panel.material": "Malzeme",
  "panel.lead": "Lead",
  "panel.fullReport": "Tam rapor görünümü",
  "panel.parts": "Parçalar",
  "panel.noParts": "Parça yok",
  "panel.measures": "Ölçüler",
  "panel.stock": "Stok",
  "panel.profile": "Profil",

  "report.kpi.labor": "İşçilik",
  "report.kpi.meta.totalEst": "toplam tahmini",
  "report.kpi.meta.items": "{n} kalem",
  "report.kpi.meta.raw": "hammadde",
  "report.kpi.meta.machining": "freze / torna / delik",
  "report.kpi.meta.setup": "setup + montaj",
  "report.kpi.meta.daysUnit": "gün",
  "report.kpi.meta.assemblyDays": "montaj ~{n}g",
  "report.kpi.meta.leadEst": "teslim tahmini",
  "report.kpi.meta.riskSummary": "risk özeti",
  "report.kpi.risk.critical": "{n} kırmızı",
  "report.kpi.risk.yellow": "{n} sarı",
  "report.kpi.risk.green": "hepsi yeşil",
  "report.kpi.goDetail": "{title} detayına git",
  "report.hero.fallbackLead":
    "Bu iş için tahmini lead yaklaşık {n} iş günü. Tam plan için rotayı açın.",
  "report.hero.fallbackEmpty":
    "Motor tahmini bitince üretim metrikleri burada görünecek.",
  "report.price.erpTitle": "Fiyat ERP stok kaydındaki birim fiyattan geliyor",
  "report.price.staleMark": " — KUR GÜNCEL DEĞİL",
  "report.price.fxSell": "× {source} satış {rate} ({date})",

  "props.title": "Özellikler",
  "props.tabsAria": "Özellik sekmeleri",
  "props.tab.part": "Parça",
  "props.tab.drawing": "Çizim",
  "props.tab.selection": "Seçim",
  "props.partCode": "parça kodu",
  "props.part": "parça",
  "props.partN": "Parça {n}",
  "props.itemNo": "kalem no",
  "props.solid": "solid",
  "props.solidIndex": "solid index",
  "props.point": "nokta (mm)",
  "props.faceIndex": "yüzey no",
  "props.class": "sınıf",
  "props.source": "kaynak",
  "props.rawData": "Ham veri",
  "props.partNo": "parça no",
  "props.description": "açıklama",
  "props.qty": "miktar",
  "props.material": "malzeme",
  "props.unit": "birim",
  "props.confidence": "güven",
  "props.risk": "risk",
  "props.suggestion": "öneri",
  "props.shortage": "eksik",
  "props.materialTry": "malzeme ₺",
  "props.stockMatch": "Stok eşleşmesi",
  "props.stockName": "stok adı",
  "props.stockCode": "stok kodu",
  "props.stockQty": "stok adet",
  "props.score": "skor",
  "props.match": "eşleşme",
  "props.stockMaterial": "stok malzeme",
  "props.unitPrice": "birim ₺",
  "props.engineMeta": "Motor meta",
  "props.rawBom": "Ham BOM",
  "props.drawingDims": "çizim boyutları",
  "props.production": "üretim",
  "props.lead": "lead",
  "props.leadDays": "{n} gün",
  "props.unitsReady": "hazır birim",
  "props.volume": "hacim",
  "props.materialCost": "Malzeme maliyeti",
  "props.noSelection": "Seçim yok",
  "props.empty": "Parça veya nokta seçin",
  "props.noPart": "Parça seçilmedi. Görüntüleyicide bir parça tıklayın.",
  "props.noBomMatch": "Bu solid için BOM satırı eşleşmedi.",
  "props.pickHint": "Görüntüleyicide bir yüzey seçin. Nokta / yüzey bilgisi burada görünür.",
  "props.noActiveDrawing": "Aktif çizim yok.",

  "bom.error": "Parse hatası oluştu.",
  "bom.retry": "Tekrar dene",
  "bom.refresh": "Yenile",
  "bom.empty": "BOM kalemi yok.",
  "bom.title": "BOM · {name}",
  "bom.noStock": "Stok yok",
  "bom.material": "Malzeme: {n} ₺",
  "bom.save": "Kaydet",
  "bom.sortHint": "Sıra: risk · eksik · parça",
  "bom.filterEmpty": "Bu filtre için satır yok.",
  "bom.col.partNo": "Parça No",
  "bom.col.qty": "Miktar",
  "bom.col.stock": "Stok",
  "bom.col.match": "Eşleşme",
  "bom.col.stockCode": "Stok Kodu",
  "bom.col.risk": "Risk",
  "bom.col.shortage": "Eksik",
  "bom.col.material": "Malzeme",
  "bom.col.desc": "Tanım",
  "bom.col.action": "Aksiyon",

  "stockFilter.aria": "Stok eşleşme filtresi",
  "stockFilter.all": "Tümü",
  "stockFilter.dimension": "Boyut",
  "stockFilter.exact": "Tam",
  "stockFilter.fuzzy": "Yaklaşık",
  "stockFilter.other": "Diğer",
  "stockFilter.none": "Eşleşme yok",

  "stockPicker.close": "Kapat",
  "stockPicker.pick": "Stok seç",
  "stockPicker.candidates": "Aday ({n})",
  "stockPicker.none": "Aday yok",
  "stockPicker.failed": "Hata: {msg}",

  "measure.count": "{n} ölçü",
  "measure.countPreview": "{n} ölçü (önizleme)",
  "measure.countDxf": "{n} ölçü (DXF)",
  "measure.none": "Ölçü yok",
  "measure.openList": "Ölçü listesini aç",
  "measure.title": "ÖLÇÜLER",
  "measure.preview": "önizleme",

  "viewer.fit": "Sığdır",
  "viewer.fitTitle": "Modeli ekrana sığdır",
  "viewer.front": "Ön",
  "viewer.frontTitle": "Ön görünüm",
  "viewer.top": "Üst",
  "viewer.topTitle": "Üst görünüm",
  "viewer.right": "Sağ",
  "viewer.rightTitle": "Sağ görünüm",
  "viewer.iso": "İzo",
  "viewer.isoTitle": "İzometrik görünüm",
  "viewer.wire": "Tel",
  "viewer.wireTitle": "Tel kafes görünümünü aç/kapat",
  "viewer.measure": "Ölç",
  "viewer.measureTitle": "İki nokta arası ölçüm modu",
  "viewer.isolate": "İzole",
  "viewer.isolateTitle": "Seçili parçayı tek başına göster",
  "viewer.empty": "Henüz çizim açılmadı. Bir DXF/STEP/DWG dosyası açın (Ctrl+O).",
  "viewer.partPickerAria": "Montaj parçaları",
  "viewer.dxfNeedParse": "DWG 2D önizleme için engine'in dosyayı parse etmesi gerekir.",
  "viewer.no2d": "2D geometri bulunamadı.",
  "viewer.reopenHint":
    "Dosyayı yeniden açın (engine çalışıyor olmalı). DWG için ODA File Converter kurulu olmalı.",
  "viewer.stepLoadFail": "3D model yüklenemedi.",
  "viewer.partFallback": "Parça {n}",
  "viewer.pickCandidate": "Aday stoklardan seçin",
  "viewer.partLabel": "Parça",
  "viewer.isolated": "izole",
  "viewer.highlight": "vurgu",
  "viewer.hover": "üzerinde",
  "viewer.loadFile": "Dosya yükleyin veya bir çizim seçin",
  "viewer.loading3d": "3D model yükleniyor…",
  "viewer.setupHint":
    "Kurulum için scripts/setup-conda-engine çalıştırın ve projeyi yerel start betiği ile başlatın.",

  "nav.account": "Hesap",
  "nav.proLicense": "Pro Atölye Lisansı",
  "nav.profile": "Profil Ayarları",
  "nav.billing": "Lisans ve Ödemeler",
  "nav.billingSoon": "Faturalama henüz yok",
  "nav.themeLight": "Açık tema",
  "nav.themeDark": "Koyu tema",
  "nav.logout": "Çıkış Yap",
  "nav.logoutFailed": "Çıkış başarısız",
  "nav.context": "Bağlam",
  "nav.holes": "{n} delik",

  "profile.identity": "Kimlik",
  "profile.refresh": "Yenile",
  "profile.loading": "Profil yükleniyor…",
  "profile.loadFailed": "Profil yüklenemedi",
  "profile.name": "Görünen ad",
  "profile.email": "E-posta",
  "profile.organization": "Organizasyon",
  "profile.orgSlug": "Organizasyon kimliği",
  "profile.role": "Rol",
  "profile.writeAccess": "Yazma yetkisi",
  "profile.canWrite.yes": "Var",
  "profile.canWrite.no": "Yok (görüntüleyici)",
  "profile.authVia": "Giriş yolu",
  "profile.role.owner": "Sahip",
  "profile.role.member": "Üye",
  "profile.role.viewer": "Görüntüleyici",
  "profile.role.service": "Servis anahtarı",
  "profile.role.unknown": "—",
  "profile.section.account": "Hesap",
  "profile.section.accountHint": "Atölyede nasıl göründüğünüz. E-posta burada değiştirilemez.",
  "profile.section.org": "Organizasyon",
  "profile.section.orgHint": "Bu oturumdaki üyelik. Rol değişikliği için sahip ile iletişime geçin.",
  "profile.section.security": "Güvenlik",
  "profile.section.securityHint": "Parolanızı güncelleyin. Bu cihazda oturumunuz açık kalır.",
  "profile.emailReadonly": "E-posta organizasyon yöneticisi tarafından yönetilir.",
  "profile.save": "Değişiklikleri kaydet",
  "profile.saving": "Kaydediliyor…",
  "profile.saved": "Profil güncellendi",
  "profile.needSession": "Düzenlemek için e-posta ve parola ile giriş yapın.",
  "profile.currentPassword": "Mevcut parola",
  "profile.newPassword": "Yeni parola",
  "profile.confirmPassword": "Yeni parolayı doğrula",
  "profile.passwordRules": "En az 8 karakter kullanın.",
  "profile.passwordTooShort": "Yeni parola en az 8 karakter olmalı.",
  "profile.passwordMismatch": "Yeni parola ve doğrulama eşleşmiyor.",
  "profile.changePassword": "Parolayı güncelle",
  "profile.changingPassword": "Güncelleniyor…",
  "profile.passwordChanged": "Parola başarıyla güncellendi",

  "stock.catalog": "Katalog",
  "stock.refresh": "Yenile",
  "stock.loading": "Stok yükleniyor…",
  "stock.loadFailed": "Stok kataloğu yüklenemedi",
  "stock.itemCount": "Kalem",
  "stock.source": "Kaynak",
  "stock.org": "Organizasyon",
  "stock.importHint": "Stok Kodu / part_no sütunlu CSV yükleyin. Organizasyon kataloğunu değiştirir.",
  "stock.importCsv": "CSV içe aktar",
  "stock.importing": "Aktarılıyor…",
  "stock.importOk": "{n} kalem aktarıldı",

  "stock.section": "kesit {n}mm",
  "stock.box": "kutu {w}×{t}mm",
  "stock.envelope": "zarf {w}×{h}mm",
  "stock.cut": "kesim {n}mm",
  "stock.drawing": "Çizim: {dims}",

  "chat.title": "Üretim Asistanı",
  "chat.trace": "İz",
  "chat.comprehensive": "Kapsamlı analiz",
  "chat.send": "Gönder",
  "chat.placeholder": "Delik, maliyet, stok, üretim sor…",
  "chat.role.you": "Sen",
  "chat.quick.volume": "Hacim",
  "chat.quick.volumePrompt": "Hacim nedir?",
  "chat.quick.holes": "Delik özeti",
  "chat.quick.cost": "Maliyet tahmini?",
  "chat.quick.stock": "Stok riski?",
  "chat.quick.route": "Üretim rotası?",
  "chat.quick.selection": "Bu seçim için özet",
  "chat.noReply": "Yanıt alınamadı.",
  "chat.drawingFallback": "çizim",
  "chat.hello":
    "Merhaba — «{name}» açık. Hacim, delik, maliyet, stok veya üretim sorabilirsin.",
  "chat.shortPrompt": "Kısaca ne sormak istediğini yaz (delik, maliyet, stok, üretim…).",
  "chat.volumeValue": "Hacim ≈ {v} m³.",
  "chat.volumeNone": "Hacim verisi yok.",
  "chat.holesDetail": "{n} delik — {parts}.",
  "chat.holesFound": "~{n} delik tespit edildi.",
  "chat.holesLimited": "Delik verisi sınırlı.",
  "chat.engineDown":
    "Engine'e ulaşılamadı. Delik, maliyet, stok veya üretim diye sor — bağlantı gelince detay açılır.",
  "chat.agent.geometry": "Geometri uzmanı",
  "chat.agent.cost": "Maliyet uzmanı",
  "chat.agent.risk": "Risk uzmanı",
  "chat.systemPrompt":
    "Atölye mühendisi gibi yanıtla. Delikleri çap gruplarıyla özetle (Ø×adet); 50+ ham satır dökme. " +
    "Üretim/tedarikte MAKE_INTERNAL vs BUY, kritik yol ve somut sıra öner. " +
    "Selam/gürültüde menü veya tam rapor basma. Selection varsa önceliklendir.",

  "trace.drawingSummary": "Çizim özeti",
  "trace.geometryDetail": "Geometri detayı",
  "trace.productionIntel": "Üretim zekası",
  "trace.workshopSolutions": "Atölye çözümleri",
  "trace.stockRisk": "Stok riski",
  "trace.partDetail": "Parça detayı",
  "trace.searchStock": "Stok arama",
  "trace.route": "Yönlendirme",
  "trace.plan": "Plan",
  "trace.reasoning": "Düşünce",
  "trace.tools": "Araç seçimi",
  "trace.prefetch": "Veri yükleme",
  "trace.agents": "Uzmanlar",
  "trace.synthesize": "Sentez",
  "trace.answer": "Yanıt",
  "trace.skipped": "Atlandı",
  "trace.chainTitle": "Düşünce zinciri",
  "trace.toolsTitle": "Araç seçimi",
  "trace.running": "Çalışıyor",
  "trace.done": "Bitti",
  "trace.ok": "Tamam",
  "trace.charsReport": "{n} karakter rapor",
  "trace.subAgents": "Sub-agent analizi",
  "trace.hideParams": "Parametreleri gizle",
  "trace.params": "Parametreler",

  "error.detailsLog": "Detaylar browser console dosyasına yazıldı.",
  "dev.file": "Dosya: {path}",

  "report.nav.overview": "Özet",
  "report.nav.cost": "Maliyet detayı",
  "report.nav.material": "Hammadde fiyatları",
  "report.nav.lead": "Lead time",
  "report.nav.route": "Üretim rotası",
  "report.nav.part": "Parça planı",
  "report.nav.parts": "Parça planları",
  "report.nav.dfm": "DFM analizi",
  "report.sectionsAria": "Rapor bölümleri",
  "report.breadcrumbAria": "Rapor konumu",
  "report.back": "Geri",
  "report.crumbRoot": "Üretim raporu",
  "report.exportOk": "Rapor dışa aktarıldı (JSON · Excel · PDF).",
  "report.exportFail": "Dışa aktarma başarısız",
  "report.export": "Dışa aktar",
  "report.title": "ÜRETİM RAPORU",
  "report.assistant": "Üretim asistanı",
  "report.error": "Rapor yüklenirken hata oluştu.",
  "report.detail": "Detay →",
  "report.refreshData": "Verileri Yenile",
  "report.exporting": "Aktarılıyor…",
  "report.exportTitle": "JSON, Excel ve PDF raporlarını dışa aktar",
  "report.exportTitleShort": "JSON, Excel, PDF",
  "report.noIntel": "Üretim verisi yok.",
  "report.noMaterialPricing":
    "Bu çizim için hammadde fiyat satırı yok. Katalog/kur verisi olan bir iş açın veya parse sonrası yenileyin.",
  "report.sidebar.summary": "İş özeti",
  "report.ai.empty": "Bu çizim için henüz AI önerisi yok.",
  "report.ai.run": "AI ile analiz et",
  "report.noPartPlan": "Parça planı bulunamadı.",
  "report.backToParts": "Tüm parçalara dön",
  "report.rev": "Rev",
  "report.kpi.productionCost": "Üretim Maliyeti",
  "report.kpi.material": "Hammadde",
  "report.kpi.machining": "İşleme",
  "report.kpi.leadTime": "Lead Time",
  "report.kpi.stockRisk": "Stok / Risk",
  "report.kpi.dfm": "DFM skoru",
  "report.scheduleAria": "Üretim zaman çizelgesi",
  "report.legendAria": "Gösterge",
  "report.costJourneyAria": "Maliyet yolculuğu",
  "report.days": "{n} gün",
  "report.stockQtyTitle": "Stok adedi",
  "report.partPlansTitle": "Parça Bazlı Üretim Planı",
  "report.assemblyTitle": "Montaj planı",
  "report.materialTitle": "Güncel Hammadde Fiyatları",
  "report.fxTitle": "Güncel Kur",
  "report.fxStale": "Kur güncel değil",
  "report.fxStaleDetail": "Kur güncel değil — {date} tarihli son bilinen kur kullanıldı.",
  "report.fxMeta": "Kur: {source} satış {pair} {rate} · {date}",
  "report.moreClasses": " · +{n} sınıf",
  "report.col.material": "Malzeme",
  "report.col.usdKg": "USD/kg Baz",
  "report.col.tryKg": "TRY/kg",
  "report.col.part": "Parça",
  "report.col.desc": "Açıklama",
  "report.col.qty": "Miktar",
  "report.col.unitPrice": "Birim Fiyat",
  "report.col.source": "Kaynak",
  "report.col.line": "Satır",
  "report.col.match": "Eşleşme",
  "report.col.stockCode": "Stok Kodu",
  "report.op.turning": "Torna",
  "report.op.drilling": "Delik",
  "report.op.cutting": "Kesim",
  "report.op.milling": "Freze",
  "report.op.welding": "Kaynak",
  "report.op.setup": "Setup",
  "report.opCostTitle": "Operasyon Maliyet Tahmini",
  "report.total": "Toplam",
  "report.labor": "İşçilik",
  "report.moreItems": "+{n} kalem daha",
  "report.costNeedsIntel": "Maliyet verisi için production_intel gerekli.",
  "report.price.erp": "ERP stok",
  "report.price.market": "Güncel Kur",
  "report.price.default": "Varsayılan",
  "report.price.unknown": "Bilinmiyor",
  "report.price.defaultTitle": "Kur/stok verisi yok — sabit varsayılan çelik fiyatı kullanıldı",
  "report.feedback.title": "Gerçek sonuç",
  "report.feedback.save": "Kaydet",
  "report.feedback.fail": "Kayıt başarısız",
  "report.feedback.ok": "Kaydedildi",
  "report.feedback.actualCost": "Gerçek maliyet (₺)",
  "report.feedback.actualLead": "Gerçek lead (gün)",
  "report.feedback.predicted": "Tahmin",
  "report.feedback.costLabel": "Maliyet (₺)",
  "report.feedback.leadLabel": "Lead (gün)",
  "report.routeTitle": "Üretim Rotası",
  "report.routePrompt":
    "Üretim rotasını atölye asistanı gibi anlat. Müşteriye / planlamacıya konuşur gibi 3-6 cümle yaz; " +
    "kritik yol, hangi parçalar paralel imal edilebilir, lead ve makine ipucunu ver. " +
    "Ham 6 satır MAKE_INTERNAL listesi dökme. Sonunda 1-2-3 aksiyon öner. Türkçe.",
  "report.routeAgent":
    "Üretim rotası asistanı: workshop_solutions ve production_intel kullan. " +
    "İnsansı, net, uygulanabilir. Koordinat/delik dökümü yok.",
  "report.route.tell": "Asistanla anlat",
  "report.route.retell": "Yeniden anlat",
  "report.route.telling": "Anlatıyor…",
  "report.route.tellTitle": "LLM ile atölye asistanı anlatımı",
  "report.route.emptyLlm": "Asistan yanıtı boş — LLM anahtarı veya parse verisini kontrol et.",
  "report.route.fail": "Asistan isteği başarısız",
  "report.route.steps": "Parça / aksiyon adımları",
  "report.route.notReady":
    "Üretim rotası henüz hazır değil — çizimi motora gönderin, rota otomatik oluşturulur.",
  "report.route.leadChip": "Lead ~{n} gün",
  "report.route.openLead": "Üretim rotası detayı →",
  "report.lead.total": "Toplam lead",
  "report.lead.materialWait": "Malzeme bekleme",
  "report.lead.assembly": "Montaj",
  "report.lead.steps": "İş adımı",
  "report.lead.noSchedule": "Zaman çizelgesi adımı yok — lead yalnızca toplam günden hesaplandı.",
  "report.lead.machine": "İşleme",
  "report.lead.wait": "Bekleme",
  "report.lead.criticalPart": "Kritik yol parçası",
  "report.part.duration": "Süre",
  "report.part.stock": "Stok",
  "report.part.position": "Montaj konumu (mm)",
  "report.part.hours": "{n} sa",
  "report.schedule.moreSteps": "+{n} adım daha",
  "report.route.moreSteps": "+{n} adım — detayda görüntüle",
  "report.route.planBadge": "plan özeti",
  "report.route.looking": "Rota verisine bakıyorum…",
  "report.route.schedule": "Zaman çizelgesi",
  "report.revision.title": "Revizyon",
  "report.revision.plan": "Plan",
  "report.ai.title": "AI Önerileri",
  "report.ai.priorityActions": "Öncelikli aksiyonlar",
  "report.ai.blockers": "Engeller",
  "report.ai.alternatives": "Alternatifler",
  "report.dfm.title": "DFM Analizi",
  "report.dfm.counts": "{critical} kritik · {warning} uyarı",
  "report.dfm.noIssues": "Yapılandırılmış DFM uyarısı yok.",
  "report.part.cost": "Maliyet",
  "report.part.ops": "Operasyon sırası",
  "report.part.noOps": "Operasyon listesi yok.",
  "report.part.leadHint": "Bu parça için tahmini lead {n} gün",
  "report.part.count": "{n} parça",
  "report.part.all": "Tümü →",
  "report.part.critical": "kritik yol",
  "report.part.solidRef": "3D solid referansı",
  "report.part.llmRefined": "Operasyonlar LLM ile rafine edildi",
  "report.type.govde": "Gövde",
  "report.type.large": "Büyük bileşen",
  "report.type.medium": "Orta bileşen",
  "report.type.component": "Bileşen",
  "report.type.small": "Küçük bileşen",
  "report.type.fastener": "Bağlantı",
  "report.dfm.scoreTitle": "Üretilebilirlik skoru",
  "report.dfm.costDrivers": "Maliyet sürücüleri",
  "report.stock.noCritical": "Kritik stok riski yok.",
  "report.schedule.waitDays": "{n} gün bekleme",
  "report.schedule.dayRange": "{start}–{end}. gün",
  "report.schedule.day0": "0. gün",
  "report.schedule.dayN": "{n}. gün",
  "report.revision.deltaDays": "{n} gün",
  "report.revision.lead": "Lead",
  "report.revision.schedule": "Çizelge",
  "report.ai.error": "Ajan hatası",
  "report.ai.refresh": "Yenile",
  "report.schedule.cut": "Kesim",
  "report.schedule.turn": "Torna",
  "report.schedule.drill": "Delik",
  "report.schedule.mill": "Freze",
  "report.schedule.weld": "Kaynak",
  "report.schedule.assembly": "Montaj",
  "report.schedule.inspect": "Kontrol",
  "report.schedule.paint": "Boya",
  "report.schedule.ship": "Sevk",

  "op.DELIK": "Delik Delme",
  "op.TORNA": "Torna",
  "op.FREZE": "Freze",
  "op.KESIM": "Kesim",
  "op.KAYNAK": "Kaynak",
  "op.MONTAJ": "Montaj",
  "op.TASLAMA": "Taşlama",
  "op.TEMIN": "Temin / satın al",
  "op.BOYA": "Boya",
  "op.KONTROL": "Kontrol",
  "op.SETUP": "Setup",

  "dev.hide": "Gizle",
  "dev.show": "Göster",
  "dev.logs": "Geliştirici logları",
  "dev.trace": "İz",

  "cache.refresh": "Yenile",
  "cache.refreshTitle": "Veriyi yenile",
  "cache.stale": "Eksik veri",
  "cache.staleTitle": "Parse verisi eksik",

  "report.sidebar.scenario": "Senaryo Analizi",
  "report.sidebar.production": "Üretim",
  "report.sidebar.ready": "Hazır ×{n}",
  "report.sidebar.needDrawing": "Senaryo analizi ve AI önerileri için bir çizim açın.",

  "match.exact": "Tam",
  "match.fuzzy": "Bulanık",
  "match.dimension": "Boyut",
  "match.embedding": "Embedding",
  "match.embedding_low": "Embedding↓",
  "match.llm": "LLM",
  "match.zilliz": "Zilliz",
  "match.zilliz_med": "Zilliz↓",
  "match.preference": "Hafıza",
  "match.none": "—",
  "match.noStockPick": "Stok eşleşmesi yok — aday seç",

  "dim.openList": "Ölçü listesini aç",
  "dim.title": "ÖLÇÜLER",
  "dim.count": "{n} ölçü",
  "dim.countPreview": "{n} ölçü (önizleme)",
  "dim.previewHint": "Önizleme ölçüleri",
  "dim.storyTitle": "Boyut turu",
  "dim.storyHint": "Ölçü adımlarını seçerek parçayı adım adım okuyun.",
  "dim.empty": "Ölçü yok",
  "dim.src.dxf": "DXF ölçü",
  "dim.src.geometry": "geometri",
  "dim.src.preview": "önizleme",
  "dim.src.text": "metin",

  "viewer.parts": "Parçalar",
  "viewer.stockBadge": "stok",
  "viewer.offlineCount": "Çevrimdışı: {count}",
  "viewer.loadError": "Yükleme hatası",
  "viewer.dragTitle": "Sürükleyerek taşı",
  "viewer.resizeTitle": "Boyutu değiştir",

  "error.boundary": "Bir hata oluştu.",
  "error.retry": "Yeniden dene",
  "error.close": "Kapat",

  "page.profile.title": "Profil",
  "page.profile.sub": "Hesabınızı, organizasyon erişiminizi ve güvenliği yönetin",
  "page.stock.title": "Stok kataloğu",
  "page.stock.sub": "BOM eşleştirme ve teklif için organizasyon stoğu",
  "common.emDash": "—",
  "common.close": "Kapat",
  "common.loading": "Yükleniyor…",
  "common.hours": "{n} sa",

  "auth.login.title": "Tekrar hoş geldiniz",
  "auth.login.blurb": "Çizimleri maliyetli teklife çevirmek için giriş yapın.",
  "auth.login.cta": "Giriş yap",
  "auth.login.switch": "Hesabınız yok mu?",
  "auth.login.switchCta": "Hesap oluştur",
  "auth.signup.title": "Hesap oluştur",
  "auth.signup.blurb": "STEP yükleyin, BOM alın, kendi tarifelerinizle teklifleyin.",
  "auth.signup.cta": "Hesap oluştur",
  "auth.signup.switch": "Zaten hesabınız var mı?",
  "auth.signup.switchCta": "Giriş yap",
  "auth.field.name": "Ad soyad",
  "auth.field.email": "İş e-postası",
  "auth.field.org": "Atölye adı",
  "auth.field.orgPh": "ör. Liman CNC",
  "auth.field.password": "Şifre",
  "auth.field.passwordCreate": "Şifre oluştur",
  "auth.field.confirm": "Şifreyi doğrula",
  "auth.passwordRules": "En az 8 karakter.",
  "auth.passwordTooShort": "Parola en az 8 karakter olmalı.",
  "auth.consent.before": "",
  "auth.consent.kvkk": "KVKK aydınlatma metnini",
  "auth.consent.between": " ve ",
  "auth.consent.terms": "kullanım şartlarını",
  "auth.consent.after": " kabul ediyorum.",
  "auth.consentRequired": "Hesap oluşturmak için KVKK aydınlatma metnini ve kullanım şartlarını kabul edin.",
  "auth.mismatch": "Henüz eşleşmiyor",
  "auth.busy": "Çalışıyor…",
  "auth.showPassword": "Şifreyi göster",
  "auth.hidePassword": "Şifreyi gizle",
  "auth.language": "Dil",
  "auth.tagline": "Çizimden maliyetli teklife.",
  "auth.step.drawing": "Çizim",
  "auth.step.features": "Özellikler",
  "auth.step.cost": "Maliyet",
  "auth.step.quote": "Teklif",
  "auth.preview.parts": "Parçalar",
  "auth.preview.partsCap": "Katalogda",
  "auth.preview.boms": "BOM",
  "auth.preview.bomsCap": "Montajlar",
  "auth.preview.rfqs": "RFQ",
  "auth.preview.rfqsCap": "Açık",
  "auth.preview.orders": "Sipariş",
  "auth.preview.ordersCap": "Atölyede",
  "auth.preview.coverage": "kapsama",
  "auth.preview.parsed": "Parse edildi · teklife hazır",
  "auth.preview.example": "Örnek",
  "auth.preview.sample": "Örnek atölye, hesabınız değil",
  "auth.orgMismatch": "Bu hesap bu çalışma alanına ait değil. Kendi çalışma alanınızın adresinden giriş yapın.",
  "auth.orgMismatchNamed": "Bu hesap bu çalışma alanına ait değil ({name}). Kendi çalışma alanınızın adresinden giriş yapın.",
  "auth.orgApexLink": "Ana giriş sayfasına git",
  "auth.orgSignupRefused": "Çalışma alanı adresinde yeni hesap açılamaz. Çalışma alanı sahibinden davet isteyin.",
  "auth.unknownWorkspace": "Bu adreste bir çalışma alanı yok.",
  "auth.orgInviteOnly": "Bu çalışma alanına davetle katılınır.",
  "auth.orgLogoAlt": "{name} logosu",

  "topbar.search": "Parça, BOM ve RFQ ara",
  "topbar.signingOut": "Çıkılıyor…",
  "topbar.signedIn": "Oturum açık",
  "home.quick.upload": "Yükle",
  "home.kpi.inCatalog": "Katalogda",
  "home.kpi.assemblies": "Okunan montaj",
  "home.kpi.checking": "Bakılıyor",
  "home.kpi.clear": "Bekleyen çizim yok",
  "home.kpi.waiting": "Sizde bekliyor",
  "home.unit.item": "kalem",
  "home.unit.items": "kalem",
  "home.unit.drawing": "çizim",
  "home.unit.drawings": "çizim",
  "home.ordersMark": "AÇIK",
  "home.coverage.title": "Teklif kapsamı",
  "home.coverage.cap": "Açık talep satırlarında",
  "home.attention.title": "Dikkat isteyen",
  "home.uploads.title": "Yüklenen çizimler",
  "home.partsAdded.title": "Eklenen parçalar",
  "home.readiness.title": "Talep hazırlığı",
  "drawings.item": "kalem",
  "drawings.items": "kalem",
  "drawings.onHand": "elde {n}",
  "drawings.costPending": "maliyet bekliyor",
  "drawings.partsCosted": "Parçalar · maliyetli",
  /** Turkish keeps the singular after a numeral, for one and for many. */
  "drawings.partsCosted.one": "parça maliyetlendi",
  "drawings.partsCosted.other": "parça maliyetlendi",
  "drawings.emptyBoms": "Henüz BOM yok.",
  "drawings.emptyParts": "Henüz parça yok.",
  "drawings.emptyReview": "İnceleme bekleyen yok.",
  "drawings.count": "{n} kalem",
  "docs.search": "Parça, BOM veya dosya ara",
  "docs.upload": "Dosya yükle",
  "docs.sort": "Sırala",
  "docs.sort.newest": "En yeni",
  "docs.sort.name": "Ad",
  "docs.sort.cost": "Son maliyet",
  "docs.view": "Görünüm",
  "docs.view.list": "Liste",
  "docs.view.cards": "Kartlar",
  "docs.tab.all": "Tümü",
  "docs.costed": "{n} maliyetli",
  "docs.lastCost": "Son maliyet {n}",
  "docs.part": "{n} parça",
  "docs.parts": "{n} parça",
  "docs.usedOne": "{n} BOM",
  "docs.usedMany": "{n} BOM",
  "docs.status.processing": "İşleniyor",
  "docs.col.name": "Ad",
  "docs.col.status": "Durum",
  "docs.col.lastCost": "Son maliyet",
  "docs.col.modified": "Son değişiklik",
  "docs.col.modifiedBy": "Değiştiren",
  "docs.col.createdBy": "Oluşturan",
  "docs.col.usedIn": "Kullanıldığı yer",
  "docs.menu.open": "Aç",
  "docs.menu.rfqs": "RFQ'ları göster",
  "docs.menu.more": "Diğer",
  "docs.emptyReviewTitle": "İnceleme gerektiren yok",
  "docs.emptyReviewBody": "Sistemin güvenle okuyamadığı parçalar burada görünür.",
  "docs.emptyMatchTitle": "“{q}” için eşleşme yok",
  "docs.emptyMatchBody": "Parça kodu, malzeme veya RFQ numarası deneyin.",
  "docs.emptyTitle": "Henüz doküman yok",
  "docs.emptyBody": "Başlamak için bir STEP, DXF, DWG veya PDF yükleyin.",
  "docs.drop": "Yüklemek için bırakın · STEP, STP, DXF, DWG, PDF",
  "docs.notifyEmpty": "Yeni bildirim yok",
  "docs.comingSoon": "{label} yakında",
  "docs.deleteBody": "{name} katalogdan çıkar. Bu çizimdeki parçalar da gider.",
  "docs.deleting": "Siliniyor…",
  "profile.nav.users": "Kullanıcılar",
  "profile.nav.alerts": "Bildirimler",
  "profile.settingsTitle": "Ayarlar",
  "profile.settingsSub": "Organizasyon, kullanıcılar ve uyarılar",
  "erp.nav.capacity": "Kapasite",
  "erp.nav.costing": "Maliyet",
  "erp.search.overview": "Stok, satınalma ve iş emri ara",
  "erp.search.movements": "Hareket ara",
  "erp.search.po": "Satınalma siparişi ara",
  "erp.search.wo": "İş emri ara",
  "erp.search.hours": "Operasyon veya tezgâh ara",
  "erp.search.machines": "Tezgâh ara",
  "erp.search.capacity": "Tezgâh ara",
  "erp.search.costing": "Maliyet kalemi ara",
  "erp.search.accuracy": "Operasyon veya parça ara",
  "erp.blurb.hours": "Açılmış iş emrinde hazırlık ve işleme saati",
  "erp.blurb.capacity": "Söz verilen tarihin arkasındaki tezgâh yükü",
  "erp.blurb.costing": "Saati paraya çeviren tarifeler",
  "erp.blurb.accuracy": "Biten operasyonda tahmin ve gerçek saat",
  "erp.skuLine": "{n} kalem",
  "erp.skuLines": "{n} kalem",
  "erp.openWoLine": "{n} açık iş emri",
  "erp.openPoLine": "{n} açık satınalma",
  "erp.movesLine": "bugün {n} {move} · {total} kayıt",
  "erp.moveOne": "hareket",
  "erp.moveMany": "hareket",
  "erp.overviewBlurb": "Stok kartı, hareketler, satınalma ve iş emirleri",
  "erp.kpi.stockMaster": "Stok kartı",
  "erp.kpi.nothingBuy": "Alınacak yok",
  "erp.kpi.needsBuy": "Satın alma gerekli",
  "erp.kpi.purchaseOrders": "Satınalma siparişleri",
  "erp.unit.item": "kalem",
  "erp.unit.items": "kalem",
  "erp.unit.order": "sipariş",
  "erp.unit.orders": "sipariş",
  "viewer.tourBack": "Geri",
  "viewer.tourNext": "İleri",

  "erp.sort.part": "Parça",
  "erp.sort.onHand": "Eldeki",
  "erp.sort.shortfall": "Eksik",
  "erp.sort.newest": "En yeni",
  "erp.sort.hours": "Tahmini saat",
  "erp.sort.number": "Numara",
  "erp.sort.total": "Tutar",
  "erp.open": "Açık",
  "erp.closed": "Kapalı",
  "live.erp.stockEmpty": "Henüz stok kalemi yok.",
  "erp.stockNoMatch": "Bu filtreye uyan kalem yok.",
  "erp.stockFilter": "Stok filtresi",
  "erp.receipt": "Giriş fişi",
  "erp.return": "İade",
  "erp.movEmptyTitle": "Henüz stok hareketi yok",
  "erp.movTitle": "Stok hareketleri",
  "erp.movNone": "Bu filtreye uyan hareket yok.",
  "erp.col.balanceAfter": "Sonraki bakiye",
  "erp.col.time": "Zaman",
  "erp.col.type": "Tür",
  "erp.col.created": "Oluşturma",
  "erp.col.estHours": "Tahmini saat",
  "live.erp.woEmpty": "Henüz iş emri yok.",
  "erp.woNoMatch": "Bu filtreye uyan iş emri yok.",
  "erp.woFilter": "İş emri filtresi",
  "live.erp.poEmpty": "Henüz satınalma siparişi yok.",
  "erp.poNoMatch": "Bu filtreye uyan sipariş yok.",
  "erp.poFilter": "Satınalma filtresi",
  "erp.po.part": "Parça no",
  "erp.po.qty": "Miktar",
  "erp.po.price": "Birim ₺",
  "live.erp.po.notes": "Not (tedarikçi, vade…)",
  "erp.po.notesLabel": "Not",
  "erp.po.creating": "Oluşturuluyor…",
  "erp.po.createDraft": "Taslak oluştur",
  "erp.hours.release": "Açık iş emri yok. Saat yazmadan önce İş emirlerinden birini serbest bırakın.",
  "erp.hours.none": "Açık iş emri yok",
  "erp.hours.view": "Görünüm",
  "erp.hours.entry": "Saat girişi",
  "erp.hours.cost": "Maliyet",
  "erp.hours.noCost": "Bu iş emri için henüz maliyet yazılmadı.",
  "erp.hours.noOps": "Bu iş emrinin rotasında operasyon yok.",
  "erp.hours.noMatch": "Aramaya uyan operasyon yok.",
  "erp.cost.material": "Malzeme",
  "erp.cost.stockIssue": "Stok çıkışı",
  "erp.cost.labour": "İşçilik",
  "erp.cost.machineRate": "Tezgâh saat ücreti",
  "erp.cost.perUnit": "Sağlam birim başına",
  "erp.cost.against": "Tahmine göre",
  "erp.cost.estimated": "{n} tahmin",
  "erp.cost.noEstimate": "Tahmin yok",
  "erp.col.item": "Kalem",
  "erp.col.basis": "Dayanak",
  "erp.col.op": "Op",
  "erp.col.operation": "Operasyon",
  "erp.col.machine": "Tezgâh",
  "erp.col.estH": "Tahmini sa",
  "erp.col.actH": "Gerçek sa",
  "erp.col.setupH": "Hazırlık sa",
  "erp.col.runH": "İşleme sa",
  "erp.col.runUnit": "İşleme sa/adet",
  "erp.col.required": "Gerekli",
  "erp.col.issued": "Çıkan",
  "erp.notAssigned": "Atanmadı",
  "erp.col.good": "Sağlam",
  "erp.col.scrap": "Fire",
  "erp.col.seq": "Sıra",
  "live.erp.machines.noRate": "ücret yok",
  "erp.machines.emptyTitle": "Henüz tezgâh yok",
  "erp.machines.emptyBody": "Saat ücreti, yazılan saati paraya çevirir. En az bir tezgâh olana kadar işçilik 0 ₺ kalır.",
  "set.org": "Organizasyon",
  "set.profile": "Profiliniz",
  "set.name": "Ad",
  "set.slug": "Kısa ad",
  "set.signedInAs": "Oturum",
  "set.displayName": "Görünen ad",
  "set.saving": "Kaydediliyor…",
  "set.save": "Kaydet",
  "set.usersNote": "Yalnızca kendi hesabınız görünür. Motor oturumdaki kullanıcıyı verir; organizasyon üyelerini listeleyen veya davet eden bir uç yok.",
  "set.notifyBlurb": "Hangi olayların, ne zaman size ulaşacağını seçin.",
  "set.reset": "Sıfırla",
  "set.events": "Olay türleri",
  "set.eventsBlurb": "Haber almak istediğiniz olayları seçin.",
  "set.reach": "Size ulaşır",
  "set.muted": "Sessiz",
  "set.held": "Sessiz pencerede bekler",
  "set.off": "Kapalı",
  "set.schedule": "İletim zamanı",
  "set.scheduleBlurb": "Uyarıların gelebileceği zamanı belirleyin.",
  "set.anytime": "Her zaman",
  "set.anytimeHint": "Uyarılar oluştuğu anda gelir",
  "set.shopHours": "Mesai saatlerinde",
  "set.shopHoursHint": "Mesai dışında bekletilir",
  "set.silent": "Sessiz",
  "set.silentHint": "Yalnızca acil işaretledikleriniz gelir",
  "set.muteAll": "Tüm uyarı kanallarını kapat",
  "set.priority": "Öncelik",
  "set.priorityBlurb": "Hangi uyarıların acil sayılacağını seçin. Yüksek olanlar sessiz pencereden de geçer.",
  "set.priHigh": "Yüksek · maliyet kilitli",
  "set.priMed": "Orta · inceleme gerekli",
  "set.priLow": "Düşük · bilgi",
  "set.local": "Bu seçimler yalnız bu cihazda durur.",
  "set.saved": "Bu cihaza kaydedildi.",
  "set.ev.parse": "Çizim okunamadı",
  "set.ev.stock": "Stok minimumun altında",
  "set.ev.rfq": "RFQ inceleme bekliyor",
  "set.ev.wo": "İş emri gecikti",
  "set.ev.supplier": "Tedarikçi teklifi geldi",
  "set.nameSaved": "Görünen ad güncellendi.",
  "set.passwordSaved": "Parola değişti.",
  "shop.companyNotSaved": "Yasal unvan, vergi dairesi, vergi numarası, adres, telefon, teklif e-postası ve logo henüz kaydedilmiyor. Kaydetmek; marj, geçerlilik, genel gider ve fire oranını organizasyona yazar.",
  "shop.logoNotSaved": "Şirket logosu henüz kaydedilmiyor.",
  "brand.title": "Çalışma alanı markası",
  "brand.blurb": "Çalışma alanı adresinizde görünür (giriş sayfası, kenar çubuğu ve tarayıcı sekmesi). Buradaki her şey herkese açıktır.",
  "brand.ownerOnly": "Markayı yalnızca çalışma alanı sahibi değiştirebilir.",
  "brand.name": "Görünen ad",
  "brand.namePh": "ör. Acme Metal",
  "brand.logo": "Logo URL'si",
  "brand.logoHint": "PNG veya SVG için bir https bağlantısı.",
  "brand.accent": "Vurgu rengi",
  "brand.accentHint": "Hex, örneğin #0c6e6b. Üzerindeki yazı okunurluk için beyaz ile siyah arasında seçilir.",
  "brand.preview": "Önizleme",
  "brand.save": "Markayı kaydet",
  "brand.saving": "Kaydediliyor…",
  "brand.saved": "Marka kaydedildi.",
  "brand.cancel": "Vazgeç",
  "brand.err.name": "1–80 karakter kullanın; < ve > olmasın.",
  "brand.err.logo": "Kullanıcı adı veya şifre içermeyen bir https URL'si girin.",
  "brand.err.accent": "Rengi #rrggbb biçiminde girin.",
  "brand.notLoaded": "Marka bilgisi yüklenemedi.",
  "shop.notSavedYet": "Henüz kaydedilmiyor.",
  "shop.quoteBlurb": "Marj ve geçerlilik organizasyonla birlikte kaydedilir. Yeni teklifler bunlarla başlar.",
  "shop.costBlurb": "Genel gider ve fire oranı organizasyonla birlikte kaydedilir ve maliyet formülünde kullanılır.",
  "shop.saved": "Marj, geçerlilik, genel gider ve fire oranı kaydedildi.",
  "settings.sub": "Çalışma alanı, atölye ücretleri, tezgâhlar ve uyarılar",
  "settings.tabs": "Ayarlar",
  "settings.tab.general": "Genel",
  "settings.tab.shop": "Atölye profili",
  "settings.tab.machines": "Tezgâhlar",
  "settings.tab.labour": "İşçilik türleri",
  "settings.kpi.workspace": "Çalışma alanı",
  "settings.kpi.currency": "Para birimi",
  "settings.kpi.machines": "Tezgâhlar",
  "settings.kpi.labour": "İşçilik türleri",
  "settings.workspace": "Çalışma alanı",
  "settings.workspaceBlurb": "Arayüz ve hesaplar için temel tercihler.",
  "settings.workspaceName": "Çalışma alanı adı",
  "settings.language": "Arayüz dili",
  "settings.lang.en": "English",
  "settings.lang.tr": "Türkçe",
  "settings.currency": "Para birimi",
  "settings.currencyUnloaded": "Para birimi yüklenmedi.",
  "settings.currencyHint": "Teklifler bu para biriminde hazırlanır.",
  "settings.currency.try": "TRY (₺)",
  "settings.currency.eur": "EUR (€)",
  "settings.currency.usd": "USD ($)",
  "settings.units": "Birim sistemi",
  "settings.unitsValue": "Metrik (mm, kg)",
  "settings.timezone": "Saat dilimi",
  "settings.number": "Sayı biçimi",
  "settings.numberHint": "Arayüz dilini izler.",
  "settings.users": "Kullanıcılar",
  "settings.noUser": "Oturum açmış kullanıcı yok.",
  "settings.cancel": "Vazgeç",
  "settings.company": "Şirket bilgileri",
  "settings.legal": "Yasal unvan",
  "settings.taxOffice": "Vergi dairesi",
  "settings.taxNumber": "Vergi numarası",
  "settings.address": "Adres",
  "settings.phone": "Telefon",
  "settings.quoteEmail": "Teklif e-postası",
  "settings.logo": "Şirket logosu",
  "settings.quoteDefaults": "Teklif varsayılanları",
  "settings.margin": "Varsayılan marj",
  "settings.notLoaded": "Yüklenmedi.",
  "settings.boughtMargin": "Satın alınan parçalarda marj",
  "settings.validity": "Teklif geçerliliği",
  "settings.days": "gün",
  "settings.payment": "Ödeme koşulları",
  "settings.note": "Teklif notu şablonu",
  "settings.cost": "Maliyet ve kapasite",
  "settings.overhead": "Genel gider payı",
  "settings.overheadHint": "Kira, enerji ve amortisman gibi dolaylı maliyetler.",
  "settings.scrap": "Varsayılan fire oranı",
  "settings.shift": "Vardiya düzeni",
  "settings.week": "Çalışma haftası",
  "settings.addMachine": "Tezgâh ekle",
  "settings.col.machine": "Tezgâh",
  "settings.col.ops": "Operasyonlar",
  "settings.col.hourly": "Saat maliyeti",
  "settings.col.setup": "Varsayılan hazırlık",
  "settings.col.capacity": "Kapasite",
  "settings.col.active": "Etkin",
  "settings.machinesUnknown": "Bu oturumda tezgâh listesi yok.",
  "settings.machinesEmpty": "Henüz tezgâh yok.",
  "settings.tryPerHour": "{value} ₺/sa",
  "settings.hoursDay": "{n} sa/gün",
  "settings.activate": "{name} etkinleştir",
  "settings.deactivate": "{name} devre dışı bırak",
  "settings.machine.title": "Tezgâh ekle",
  "settings.machine.body": "Parça operasyonları, yetenek ve ölçüye göre tezgâhlara gider. Değerleri gerçek sürelerden sonra düzeltebilirsiniz.",
  "settings.machine.name": "Tezgâh adı",
  "settings.machine.type": "Tür",
  "settings.machine.code": "Kod",
  "settings.machine.ops": "Operasyonlar",
  "settings.notStored": "Kayıtlı değil.",
  "settings.machine.hourly": "Saat maliyeti",
  "settings.machine.hourlyHint": "Enerji, amortisman ve bakım.",
  "settings.machine.setup": "Varsayılan hazırlık",
  "settings.machine.sheet": "En büyük sac ölçüsü",
  "settings.machine.thickness": "En büyük kalınlık",
  "settings.machine.operator": "Operatör maliyeti dahil",
  "settings.machine.save": "Tezgâhı kaydet",
  "settings.addLabour": "İşçilik türü ekle",
  "settings.col.role": "Rol",
  "settings.col.used": "Kullanıldığı operasyonlar",
  "settings.col.rate": "Saat ücreti",
  "settings.col.people": "Kişi",
  "settings.col.updated": "Son güncelleme",
  "settings.labourRole": "Atölye işçilik ücreti",
  "settings.op.grinding": "Taşlama",
  "settings.op.assembly": "Montaj",
  "settings.op.programming": "Programlama",
  "settings.op.deburring": "Çapak alma",
  "settings.labourUnknown": "Kayıtlı işçilik türü yok.",
  "settings.labourEmpty": "Kayıtlı işçilik ücreti yok.",
  "settings.labourHow": "Tezgâh ve işçilik ücretleri nasıl birleşir",
  "settings.labourHowBody": "Tezgâh operasyonları, Tezgâhlar sekmesindeki saat maliyetini kullanır. Taşlama, montaj, programlama ve çapak alma bu atölye işçilik ücretini kullanır.",
  "settings.labour.title": "İşçilik türü ekle",
  "settings.labour.body": "Atölye tek bir işçilik ücreti saklar; taşlama, montaj, programlama ve çapak alma için.",
  "settings.labour.role": "Rol",
  "settings.labour.rate": "Saat ücreti",
  "settings.labour.people": "Kişi",
  "settings.labour.save": "Kaydet",
  "settings.err.pct": "0 ile 100 arasında bir yüzde girin.",
  "settings.err.days": "Gün sayısı girin.",
  "settings.err.code": "Bir tezgâh kodu girin.",
  "settings.err.hourly": "0 veya daha büyük bir saat maliyeti girin.",
  "settings.err.machineE2e": "Tezgâhlar bu oturumda kaydedilmez.",
  "settings.err.labourUnloaded": "İşçilik ücreti yüklenmedi.",
  "settings.err.labourRate": "0 veya daha büyük bir saat ücreti girin.",
  "settings.err.labourE2e": "İşçilik türleri bu oturumda kaydedilmez.",
  "integrations.emptyTitle": "Entegrasyonlar henüz kullanılamıyor",
  "integrations.emptyBody": "Ayarlanacak bir bağlayıcı yok. Üründe bir bağlayıcı olana kadar bu sayfa boş kalır.",

  "erp.export": "Dışa aktar",
  "erp.cancel": "Vazgeç",
  "erp.rate": "Ücret",
  "erp.group": "Grup",
  "erp.hours": "Saat",
  "erp.openCol": "Aç",
  "erp.quantity": "Miktar",
  "erp.sourceJob": "Kaynak iş",
  "erp.progress": "İlerleme",
  "erp.release": "Serbest bırak",
  "erp.complete": "Tamamla",
  "erp.submit": "Gönder",
  "erp.receive": "Teslim al",
  "erp.allWo": "Tüm iş emirleri",
  "erp.woView": "İş emri görünümü",
  "erp.estimated": "Tahmin",
  "erp.recorded": "Yazılan",
  "erp.fromRouting": "Rotadan",
  "erp.clocked": "İşlenen",
  "erp.clockedSoFar": "Şimdiye kadar",
  "erp.hoursVariance": "Saat sapması",
  "erp.actualVsEst": "Gerçek / tahmin",
  "erp.scrapRate": "Fire oranı",
  "erp.goodVsScrap": "Sağlam / fire",
  "erp.goodScrap": "Sağlam / fire",
  "erp.completion": "Tamamlanma",
  "erp.goodOf": "{qty} adetten {good} sağlam",
  "erp.noQty": "Siparişte miktar yok",
  "erp.scrapped": "{n} fire",
  "erp.variance": "Sapma",
  "erp.labourAndMaterial": "İşçilik ve malzeme",
  "erp.costSummary": "Maliyet özeti",
  "erp.noReleasedShort": "Açık iş emri yok.",
  "erp.clocking": "Saat yazımı",
  "erp.sort.sequence": "Sıra",
  "erp.sort.longest": "En uzun",
  "erp.sort.workOrder": "İş emri",
  "erp.noMaterial": "Bu iş emrine ayrılmış malzeme yok.",
  "erp.issueN": "{n} çıkar",
  "erp.issuedDone": "Çıktı",
  "erp.noCostRollup": "Henüz maliyet yok. Önce saat yazın veya malzeme çıkın.",
  "erp.labourShare": "İşçilik payı",
  "erp.pctOfTotal": "toplamın %{n}",
  "erp.shopOff": "Bu organizasyonda atölye takibi kapalı.",
  "erp.start": "Başlat",
  "erp.finish": "Bitir",
  "erp.po.new": "Yeni satınalma",
  "erp.po.linePart": "Satır {n} parça",
  "erp.po.lineQty": "Satır {n} miktar",
  "erp.po.linePrice": "Satır {n} birim fiyat",
  "live.erp.po.removeLine": "Satır {n} sil",

  "erp.st.released": "Serbest",
  "erp.st.completed": "Tamamlandı",
  "erp.st.done": "Bitti",
  "erp.st.closed": "Kapalı",
  "erp.st.running": "İşleniyor",
  "erp.st.pending": "Bekliyor",
  "erp.st.active": "Aktif",

  "erp.allMachines": "Tüm tezgâhlar",
  "erp.machineView": "Tezgâh görünümü",
  "erp.editRates": "Ücretleri düzenle",
  "erp.editRate": "Ücreti düzenle",
  "erp.thisWeek": "Bu hafta",
  "erp.weekBlurb": "Açık iş emirlerinin beş günlük kapasiteye yazdığı rota saatleri",
  "erp.scheduled": "Planlanan",
  "erp.hoursBooked": "Yazılan saat",
  "erp.utilisation": "Doluluk",
  "erp.againstCap": "{n} kapasiteye göre",
  "erp.noCapacity": "Kapasite yok",
  "erp.overCapacity": "Kapasite üstü",
  "erp.pastWeek": "Haftanın tuttuğundan fazla",
  "erp.withinCap": "Kapasite içinde",
  "erp.routingBooked": "Açık iş emirlerinin yazdığı rota saatleri",
  "erp.hourlyRate": "Saat ücreti",
  "erp.hourlyRateField": "Saat ücreti ₺/sa",
  "erp.capacity": "Kapasite",
  "erp.capacityDay": "Kapasite sa/gün",
  "erp.notSet": "Yok",
  "erp.notSetLabour": "Yok. İşçilik 0 ₺ kalır",
  "erp.hPerDay": "{n} sa/gün",
  "erp.machineFallback": "Tezgâh",
  "erp.machineList": "Tezgâh listesi",
  "erp.ratePerH": "Ücret ₺/sa",
  "erp.addMachine": "Tezgâh ekle",
  "erp.addMachineBody": "Ad, grup ve saat ücreti. Gerçek maliyet için gereken bu.",
  "erp.add": "Ekle",
  "erp.setRates": "Saat ücretlerini yaz",
  "erp.setRatesBody": "Hazırlık ve işleme ücretleri ayrıysa onları da ayırın.",
  "erp.setRatesCta": "Ücret yaz",
  "erp.linkOps": "Operasyonlara bağla",
  "erp.linkOpsBody": "Rota adımlarını tezgâha bağlayın ki tahmin doğru ücreti seçsin.",
  "erp.link": "Bağla",
  "erp.code": "Kod",
  "erp.sortCode": "Sıra · kod",
  "erp.sortRate": "Sıra · ücret",
  "erp.machines.searchEmpty": "Aramaya uyan tezgâh yok.",
  "erp.machines.noneYet": "Henüz tezgâh yok. Saat ücreti olan bir tezgâh gelene kadar işçilik 0 ₺ kalır.",
  "erp.load": "Yük",
  "erp.booked": "Yazılan",
  "erp.noOpenBooks": "Bu tezgâhı yazan açık iş emri yok.",
  "erp.noCapacitySet": "{n} · kapasite yok",
  "erp.ofCapacity": "{capacity} içinden {booked}",
  "erp.rateError": "Saat ücreti 0 veya daha büyük bir sayı olmalı.",
  "erp.capError": "Kapasite 0 veya daha büyük bir sayı olmalı.",
  "erp.rateFor": "{code} saat ücreti",

  "erp.movFilter": "Hareket türü",
  "erp.receiveStock": "Stok girişi",
  "erp.receiveBody": "Gelen malzemeyi satınalma siparişine veya elle kayda yazın.",
  "erp.issueToWo": "İş emrine çıkış",
  "erp.issueBody": "İş emri açılınca malzemeyi stoktan düşün.",
  "erp.adjustQty": "Miktar düzelt",
  "erp.adjustBody": "Sayım, fire veya talaş iadesinden sonra eldeki miktarı düzeltin.",
  "erp.importCsv": "CSV içe al",
  "erp.importBody": "Açılış bakiyesini mevcut tablonuzdan toplu yükleyin.",
  "erp.importing": "Alınıyor…",
  "erp.import": "İçe al",
  "erp.movExplain": "Her giriş, çıkış ve düzeltme zaman damgasıyla burada durur. Eldeki miktar böyle açıklanır.",

  "erp.mostLoaded": "En dolu",
  "erp.mostHours": "En çok saat",
  "erp.scheduleWo": "İş emri planla",
  "erp.bookedCaption": "Açık iş emirlerindeki rota saati",
  "erp.capacityCaption": "Aktif tezgâhlar, 5 gün",
  "erp.overbooked": "Aşırı dolu",
  "erp.overbookedCaption": "Kapasiteyi aşan tezgâhlar",
  "erp.unassigned": "Atanmamış",
  "erp.unassignedCaption": "Rotada tezgâh yok",
  "erp.nothingBooked": "Yazılmış iş yok.",
  "erp.noActiveMachines": "Planlanacak aktif tezgâh yok.",
  "erp.noMachineFilter": "Bu filtreye uyan tezgâh yok.",
  "erp.hoursFoot": "Saatler, açık iş emrinin adlandırdığı tezgâha yazılır.",
  "erp.loadedPct": "{label} · %{pct} dolu",
  "erp.piece": "adet",
  "erp.pieces": "adet",
  "erp.booking": "{what}, {qty} {unit}. Tahmin {hours}{setup}.{status}",
  "erp.inclSetup": ", hazırlık {h}",
  "erp.runningNow": " Şu an işleniyor.",
  "erp.doneNow": " Bitti.",
  "erp.opMark": "op {n}",

  "erp.cost.rates": "Ücretler",
  "erp.cost.margin": "Marj",
  "erp.cost.driver": "Maliyet kalemi",
  "erp.cost.readBy": "Motor her RFQ satırını fiyatarken bunu okur.",
  "erp.cost.savedNote": "Organizasyona kaydedildi. Açık teklifler sonraki hesapta bunu alır.",
  "erp.cost.rateDefaults": "Varsayılan ücretler",
  "erp.cost.rateDefaultsBlurb": "Parkta o işlem için ücreti olan tezgâh yoksa kullanılır. Alan boşsa şablona düşülür.",
  "erp.cost.machineLabour": "Tezgâh ve işçilik",
  "erp.cost.pricedNow": "Teklifin şu an kullandığı fiyat",
  "erp.cost.pricedNowBlurb": "Tezgâh parkı bu varsayılanların önündedir, varsayılanlar da şablonun önündedir.",
  "erp.cost.process": "İşlem",
  "erp.cost.source": "Kaynak",
  "erp.cost.ratesTitle": "Tezgâh ve işçilik ücretleri",
  "erp.cost.ratesBlurb": "Bir saatin tezgâh başına maliyeti. İşlem medyanı, değişiklikten sonra fiyatlanan teklif ve iş emirlerini belirler.",
  "erp.cost.noActive": "Aktif tezgâh yok. Biri gelene kadar teklifler yukarıdaki varsayılan ücretleri kullanır.",
  "erp.cost.pricedCount": "{total} aktif tezgâhtan {priced} tanesinin ücreti var.",
  "erp.cost.materialOverhead": "Malzeme ve genel gider",
  "erp.cost.materialBlurb": "Satırdaki malzeme çizimden, stok fiyatından veya tedarikçiden gelir. Buradaki çelik fiyatı kg başına yedektir. Genel gider her teklif satırında operasyon ve malzemenin üstüne eklenir.",
  "erp.cost.overhead": "Genel gider %",
  "erp.cost.scrapAllow": "Fire payı % (raporda, fiyata girmez)",
  "erp.cost.steel": "Yedek çelik fiyatı ₺/kg",
  "erp.cost.market": "piyasa",
  "erp.cost.currency": "Para birimi",
  "erp.cost.marginDefaults": "Marj ve teklif varsayılanları",
  "erp.cost.marginBlurb": "Motor marj önerisine bu varsayılandan başlar ve kazanma oranıyla oynar. Son marjı onaylayan kişi teklifte sabitler. Yuvarlama ve geçerlilik teklif PDF'ine yazılır.",
  "erp.cost.marginPct": "Varsayılan marj %",
  "erp.cost.validity": "Teklif geçerliliği, gün",
  "erp.cost.leadBuffer": "Termin payı, gün",
  "erp.cost.rounding": "Yuvarlama",
  "erp.cost.noRounding": "Yuvarlama yok",
  "erp.cost.nearest1": "En yakın 1 ₺",
  "erp.cost.nearest10": "En yakın 10 ₺",
  "erp.cost.nearest100": "En yakın 100 ₺",
  "erp.cost.labourH": "İşçilik ₺/sa",
  "erp.cost.turningH": "Torna ₺/sa",
  "erp.cost.millingH": "Freze ₺/sa",
  "erp.cost.cuttingH": "Kesim / lazer ₺/sa",
  "erp.cost.drillingH": "Delme ₺/sa",
  "erp.cost.weldingH": "Kaynak ₺/sa",
  "erp.cost.bendingH": "Bükme ₺/sa",
  "erp.cost.turning": "Torna",
  "erp.cost.milling": "Freze",
  "erp.cost.cutting": "Kesim / lazer",
  "erp.cost.drilling": "Delme",
  "erp.cost.welding": "Kaynak",
  "erp.cost.bending": "Bükme",

  "erp.acc.under": "Eksik fiyat",
  "erp.acc.watch": "İzle",
  "erp.acc.target": "Hedefte",
  "erp.acc.over": "Fazla fiyat",
  "erp.acc.worst": "En kötü oran",
  "erp.acc.mostJobs": "En çok iş",
  "erp.acc.mostHours": "En çok saat",
  "live.erp.acc.variance": "Operasyon sapması",
  "erp.acc.across": "{n} biten operasyon",
  "erp.acc.noneYet": "Biten operasyon yok. Önce açık bir iş emrine saat yazın.",
  "erp.acc.noMatch": "Bu filtreye uyan operasyon yok.",
  "erp.acc.jobs": "İş",
  "erp.acc.clock": "Saat yaz",
  "erp.acc.clockBody": "Açık iş emrine süre, sağlam ve fire yazın.",
  "erp.acc.openTerminal": "Terminali aç",
  "erp.acc.closeWo": "İş emrini kapat",
  "erp.acc.closeBody": "Kapanış, bu raporun okuduğu gerçek saati yazar.",
  "erp.acc.closeCta": "İş emrini kapat",
  "erp.acc.compare": "Tahminle karşılaştır",
  "erp.acc.compareBody": "İlk iş kapanınca operasyon bazında sapmayı görün.",
  "erp.acc.preview": "Önizleme",
  "erp.acc.emptyTitle": "Henüz karşılaştırılacak bir şey yok",
  "erp.acc.emptyBody": "Biten operasyonlarda tahmin ile gerçek saati karşılaştırır. Oran 1'in üstündeyse o işlemi düşük fiyatlıyoruz.",
  "erp.acc.exportTitle": "Raporu dışa aktar",
  "erp.acc.exportBody": "Sapma tablosunu maliyet sayfanıza gönderin. Tablo oluşunca.",
  "erp.acc.allOps": "Tüm operasyonlar",
  "erp.acc.ratioTitle": "Gerçek / tahmin oranı",
  "erp.acc.ratioBlurb": "Oran 1'in üstündeyse düşük fiyatlamaya devam ediyoruz",
  "erp.acc.avg": "Ortalama oran · {n} {unit} üzerinde saate göre",
  "erp.acc.opOne": "operasyon",
  "erp.acc.opMany": "operasyon",
  "erp.acc.seriesRatio": "Gerçek / tahmin",
  "erp.acc.emptyChart": "Karşılaştırılacak bitmiş operasyon yok.",
  "erp.acc.estimateMet": "Tahmin tuttu",
  "erp.acc.byOp": "Operasyona göre sapma",
  "erp.acc.byOpBlurb": "Tahmin ve gerçek, saat olarak",

  "erp.ov.openWo": "Açık iş emri",
  "erp.ov.openCount": "{n} AÇIK",
  "erp.ov.coverage": "Stok karşılama",
  "erp.ov.againstMin": "Minimum seviyelere göre",
  "erp.ov.onTrack": "Yolunda",
  "erp.ov.action": "Müdahale gerekli",
  "erp.ov.share": "Minimumun üstünde veya eşit izlenen kalemlerin payı",
  "erp.ov.noMin": "Minimumu yazılmış kalem yok",
  "erp.ov.setMin": "Karşılamayı izlemek için bir kaleme minimum yazın.",
  "erp.ov.atMin": "{tracked} izlenen kalemden {ok} tanesi minimumda veya üstünde",
  "erp.ov.addStock": "Stok ekle",
  "erp.ov.nothingBlocking": "Şu an engel yok.",
  "erp.ov.lastN": "Son {n} gün",
  "erp.ov.openMovements": "Hareketleri aç",
  "erp.ov.noMovesWindow": "Son {n} günde stok hareketi yok.",
  "erp.ov.noMoves": "Hareket yok",
  "erp.ov.oneMove": "Bir hareket",
  "erp.ov.moving": "Hareket var",
  "erp.ov.moveCallout": "bugün {n} {move} · {days} günde {total}",
  "erp.ov.stockValue": "Stok değeri",
  "erp.ov.openStock": "Stoğu aç",
  "erp.ov.committed": "Ayrılmış",
  "erp.ov.pctOnHand": "eldekinin %{n}",
  "erp.ov.acrossSku": " · fiyatlı {n} kalem",
  "erp.ov.acrossSkus": " · fiyatlı {n} kalem",
  "erp.ov.readiness": "ERP hazırlığı",
  "erp.ov.readinessBlurb": "Bir işin maliyetlenebilmesi için gerekenler",
  "erp.ov.setup": "Kurulum",
  "erp.ov.incomplete": "Eksik",
  "erp.ov.ready": "Hazır",
  "erp.ov.next": "Sonraki adım",
  "erp.ov.nextStock": "Satınalma ve iş emirlerinin çekecek bir şeyi olsun diye stok kalemi ekleyin.",
  "erp.ov.nextMachine": "Saat ücreti olan bir tezgâh ekleyin. Ücret yazılana kadar işçilik 0 ₺ kalır.",
  "erp.ov.nextWo": "Bir iş emrini serbest bırakın. Saat yazılmadan maliyet boş kalır.",
  "erp.ov.releaseWo": "İş emrini serbest bırak",
  "erp.ov.activity": "Son hareketler",
  "erp.ov.noActivity": "Henüz ERP hareketi yok.",
  "erp.ov.noKind": "Bu türde henüz bir şey yok.",
  "erp.ov.pricedOf": "{total} taneden {n} fiyatlı",
  "erp.ov.nDraft": "{n} taslak",

  "erp.attn.belowMin": "{name} minimumun altında",
  "erp.attn.noMachines": "Tezgâh tanımlı değil",
  "erp.attn.noRate": "Hiçbir tezgâhın saat ücreti yok",
  "erp.attn.minimum": "Minimum",
  "erp.attn.needed": "Gerekli",
  "erp.attn.atLeast1": "en az 1",
  "erp.attn.reserve": "İş emrini serbest bırakmadan önce rezerve edin veya satınalma açın.",
  "erp.attn.rateNote": "Saat ücreti, yazılan saati paraya çevirir. Bir tezgâhın ücreti olana kadar işçilik 0 ₺ kalır.",
  "erp.attn.srcStock": "ERP · Stok",
  "erp.attn.srcMachines": "ERP · Tezgâhlar",
  "erp.kind.receipts": "Girişler",
  "erp.kind.issues": "Çıkışlar",
  "erp.kind.adjust": "Düzeltme",
  "erp.kind.scrap": "Fire",
  "erp.kind.returns": "İadeler",
  "erp.day.mon": "Pzt",
  "erp.day.tue": "Sal",
  "erp.day.wed": "Çar",
  "erp.day.thu": "Per",
  "erp.day.fri": "Cum",
  "erp.day.sat": "Cmt",
  "erp.day.sun": "Paz",
  "erp.acc.shopOff": "Bu organizasyonda atölye takibi kapalı, karşılaştırılacak yazılmış saat yok.",
  "erp.cap.shopOff": "Atölye takibi kapalı, rota saati yazılamaz.",
  "erp.cap.partial": "Bazı rotalar okunamadı. Yük eksik.",
  "erp.machineCodeRequired": "Tezgâh kodu gerekli.",

  "quotePdf.title": "Teklif PDF",
  "quotePdf.inclVat": "KDV dahil",
  "quotePdf.thumbs": "Parça görselleri",
  "quotePdf.codes": "Parça kodları",
  "quotePdf.prices": "Birim fiyatlar",
  "quotePdf.language": "Belge dili",
  "quotePdf.langEn": "English",
  "quotePdf.langTr": "Türkçe",
  "quotePdf.currency": "Para birimi",
  "quotePdf.currencyTry": "TRY (₺)",
  "quotePdf.currencyEur": "EUR (€)",
  "quotePdf.currencyUsd": "USD ($)",
  "quotePdf.noRate": "Kur kayıtlı değil, bu para birimi yazılamaz.",
  "quotePdf.disclaimer": "Maliyet ve marj PDF'e hiç yazılmaz. Teklif indirilir; SemantiCAD gönderimi izlemez.",
  "quotePdf.download": "PDF indir",
  "quotePdf.preparing": "Hazırlanıyor…",
  "quotePdf.back": "Taslağa dön",
  "quotePdf.close": "Kapat",
  "quotePdf.docTitle": "TEKLİF",
  "quotePdf.number": "No",
  "quotePdf.date": "Tarih",
  "quotePdf.validUntil": "Geçerlilik",
  "quotePdf.validDays": "{days} gün",
  "quotePdf.payment": "Ödeme",
  "quotePdf.customer": "MÜŞTERİ",
  "quotePdf.subject": "KONU",
  "quotePdf.colPart": "Parça",
  "quotePdf.colCode": "Kod",
  "quotePdf.colQty": "Adet",
  "quotePdf.colUnit": "Birim fiyat",
  "quotePdf.colTotal": "Toplam",
  "quotePdf.subtotal": "Ara toplam",
  "quotePdf.vat": "KDV %{rate}",
  "quotePdf.grand": "Genel toplam",
  "quotePdf.lead": "Termin: {days} gün",
  "quotePdf.pricesExVat": "Fiyatlar KDV hariçtir.",
  "quotePdf.page": "Sayfa {page} / {pages}",
  "quotePdf.prepared": "SemantiCAD ile hazırlandı",
  "quotePdf.lineFallback": "Kalem {n}",
  "quotePdf.tax": "VD: {value}",

  "ds.sidebar.collapse": "Kenar çubuğunu daralt",
  "ds.sidebar.expand": "Kenar çubuğunu genişlet",
  "ds.sidebar.nav": "Gezinti",
  "ds.list.sortBy": "{column} sütununa göre sırala",
  "ds.list.sortedAsc": "artan",
  "ds.list.sortedDesc": "azalan",
  "ds.topbar.searchLabel": "Ara",
  "ds.topbar.themeToDark": "Koyu tema",
  "ds.topbar.themeToLight": "Açık tema",
  "ds.topbar.notifications": "Bildirimler",
  "ds.alert.title": "Senden beklenen",
  "ds.alert.cat.stock": "Stok eşleşmesi yok",
  "ds.alert.cat.bom": "Onay bekleyen BOM",
  "ds.alert.cat.confidence": "Düşük güvenli parça",
  "ds.alert.cat.dfm": "DFM uyarısı",
  "ds.alert.cat.price": "Fiyat onayı",
  "ds.alert.cat.setup": "Kurulum",
  "ds.setup.progress": "{done} / {total}",
  "ds.setup.done": "Tamam",
  "ds.setup.next": "Sıradaki",
  "ds.setup.later": "Sonra",
  "ds.stepper.progress": "Aşama {current} / {total}: {label}",
  "ds.stepper.next": "sıradaki: {label}",
  "ds.stepper.tip": "{n} · {label} — {state}",
  "ds.stepper.state.done": "tamamlandı",
  "ds.stepper.state.current": "şu anki",
  "ds.stepper.state.upcoming": "sırada",
  "ds.ask.send": "Gönder",
  "ds.attention.example": "örnek",
  "ds.attention.emptyTitle": "Dikkat gerektiren parça yok",
  "ds.attention.emptyBody": "Güveni %70'in altında olan, DFM uyarısı bulunan veya stok eşleşmesi olmayan parçalar burada görünür.",
  "ds.stage.files": "Dosyalar",
  "ds.stage.stock": "Stok eşleştirme",
  "ds.stage.bom": "BOM",
  "ds.stage.params": "Parametreler",
  "ds.stage.cost": "Maliyet",
  "ds.stage.quote": "Teklif",
  "ds.stage.outcome": "Sonuç",
  "ds.gallery.welcome": "Hoş geldin, {name}",
  "ds.gallery.brand": "Semanti",
  "ds.gallery.brandAccent": "CAD",
  "ds.gallery.mark": "S",
  "ds.gallery.userName": "Örnek kullanıcı",
  "ds.gallery.userEmail": "owner@example.local",
  "ds.gallery.initials": "ÖR",
  "ds.gallery.searchPlaceholder": "RFQ, belge veya parça ara",
  "ds.gallery.primary": "Yeni teklif",
  "ds.gallery.dueTitle": "Terminler",
  "ds.gallery.dueMeta": "Örnek",
  "ds.gallery.overdue": "Geciken",
  "ds.gallery.dueToday": "Bugün",
  "ds.gallery.thisWeek": "Bu hafta",
  "ds.gallery.setupTitle": "Atölye kurulumu",
  "ds.gallery.stepMachines": "Tezgâhlar",
  "ds.gallery.stepMachinesBody": "Henüz yok. İşçilik maliyeti için tezgâh ekle.",
  "ds.gallery.stepStock": "Malzeme ve stok",
  "ds.gallery.stepStockBody": "Örnek stok kalemi.",
  "ds.gallery.stepPricing": "Fiyat ve marj",
  "ds.gallery.stepPricingBody": "Varsayılan marjı ve genel giderleri belirle.",
  "ds.gallery.add": "Ekle",
  "ds.gallery.import": "İçe aktar",
  "ds.gallery.setupAction": "Kur",
  "ds.gallery.rfqTitle": "Son RFQ'lar",
  "ds.gallery.colRfq": "RFQ",
  "ds.gallery.colStage": "Aşama",
  "ds.gallery.colDue": "Termin",
  "ds.gallery.allRfqs": "RFQ'lara git",
  "ds.gallery.exampleRfq": "Örnek RFQ",
  "ds.gallery.exampleRfqId": "RFQ-EXAMPLE-0001",
  "ds.gallery.exampleRfq2": "Örnek plaka",
  "ds.gallery.exampleRfq2Id": "RFQ-EXAMPLE-0002",
  "ds.gallery.exampleDue": "4 Eki",
  "ds.gallery.exampleRfq3": "Örnek gövde",
  "ds.gallery.exampleRfq3Id": "RFQ-EXAMPLE-0003",
  "ds.gallery.exampleRfq4": "Örnek kapak",
  "ds.gallery.exampleRfq4Id": "RFQ-EXAMPLE-0004",
  "ds.gallery.exampleRfq5": "Örnek flanş",
  "ds.gallery.exampleRfq5Id": "RFQ-EXAMPLE-0005",
  "ds.gallery.askTitle": "AI'ya sor",
  "ds.gallery.askMeta": "RFQ, parça ve stok hakkında",
  "ds.gallery.askPlaceholder": "Verilerin hakkında bir şey sor",
  "ds.gallery.suggest1": "Hangi örnek satırların stok eşleşmesi yok?",
  "ds.gallery.suggest2": "Örnek RFQ'yu ne bekletiyor?",
  "ds.gallery.suggest3": "Örnek işçilik neden 0 maliyetli?",
  "ds.gallery.attentionTitle": "Dikkat gerektiren parçalar",
  "ds.gallery.partsCount": "{count} parça",
  "ds.gallery.partMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.partReason": "Güven %62",
  "ds.gallery.partDfmName": "Örnek köşebent",
  "ds.gallery.partDfm": "DFM uyarısı",
  "ds.gallery.partStockName": "Örnek mil",
  "ds.gallery.partStock": "Stok eşleşmesi yok",
  "ds.gallery.review": "İncele",
  "ds.gallery.taskStockMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.match": "Eşleştir",
  "ds.gallery.taskBomMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.approve": "Onayla",
  "ds.gallery.taskConfMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.open": "Aç",
  "ds.gallery.taskDfmMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.taskPriceMeta": "RFQ-EXAMPLE-0001",
  "ds.gallery.taskSetupMeta": "Ayarlar · Tezgâhlar",
  "ds.gallery.addMachine": "Tezgâh ekle",
  "ds.gallery.toast": "Örnek bildirim",

  "sidebar.hint.production": "İş emirleri, operasyonlar ve atölye süresi",
  "production.title": "Üretim",
  "production.sub": "İş emirleri ve üzerlerine işlenen süre.",
  "production.search": "Numara, parça veya not ara",
  "production.filters": "İş emirlerini süz",
  "production.filter.all": "Tümü",
  "production.filter.open": "Açık",
  "production.filter.closed": "Kapalı",
  "production.kpi.open": "Açık",
  "production.kpi.released": "Serbest",
  "production.kpi.closed": "Kapalı",
  "production.kpi.hours": "Açık tahmini saat",
  "production.col.wo": "İş emri",
  "production.col.notes": "Notlar",
  "production.emptyTitle": "Henüz iş emri yok",
  "production.emptyBody": "Bir iş atölyeye bırakıldığında iş emri burada görünür.",
  "production.noMatchTitle": "“{query}” için eşleşme yok",
  "production.noMatchHint": "Başka bir numara veya parça deneyin.",
  "production.noFilter": "Bu süzgeçte iş emri yok.",
  "production.unavailableTitle": "Atölye takibi kapalı",
  "production.unavailableBody": "İş emri takibi bu organizasyon için açık değil. Açılana kadar gösterilecek kayıt yok.",
  "production.bulk.one": "{n} iş emri seçili",
  "production.bulk.many": "{n} iş emri seçili",
  "production.bulk.export": "Dışa aktar",
  "production.bulk.release": "Taslakları serbest bırak",
  "production.bulk.clear": "Seçimi temizle",
  "production.menu.more": "Diğer",
  "production.menu.open": "Aç",
  "production.menu.release": "Serbest bırak",
  "production.menu.complete": "Tamamla",
  "production.select": "{name} seç",
  "production.range": "{from}–{to} / {total}",
  "production.back": "Tüm iş emirleri",
  "production.missing": "Bu iş emri listede yok.",
  "production.planned": "Planlanan",
  "production.actual": "Gerçekleşen",
  "production.qtyGood": "Sağlam / sipariş",
  "production.goodScrap": "Sağlam / fire",
  "production.orderQty": "Sipariş {n}",
  "production.actions": "Başlat / bitir",
  "production.shopDetail": "Atölye takibi kapalıyken operasyon, malzeme ve maliyet görünmez.",
  "production.notice.released": "{n} taslak serbest bırakıldı.",
  "production.notice.releasedMany": "{n} taslak serbest bırakıldı.",
  "production.notice.none": "Yalnızca taslaklar serbest bırakılabilir.",
  "production.notice.completed": "İş emri tamamlandı.",
  "production.cost.perGood": "Sağlam adet başı",
  "production.cost.variance": "Maliyet farkı",
  "production.cost.hoursVar": "Saat farkı",
  "production.setupRun": "Hazırlık {setup} · işlem {run}",
  "production.section.operations": "Operasyonlar",
  "production.section.materials": "Malzemeler",
  "production.section.cost": "Maliyet",
  // Settings · Process recipes (#80)
  "proc.tab": "Süreç reçeteleri",
  "proc.title": "Süreç reçeteleri",
  "proc.blurb": "Yeni RFQ satırları operasyonlarını, hazırlık ve işleme sürelerini bu reçetelerden kopyalar. Bir reçeteyi değiştirmek, daha önce uygulandığı satırları değiştirmez.",
  "proc.new": "Yeni reçete",
  "proc.loading": "Yükleniyor…",
  "proc.empty": "Henüz reçete yok.",
  "proc.notLoaded": "Bu oturumda reçeteler yüklenmedi.",
  "proc.seeded": "Varsayılan",
  "proc.custom": "Özel",
  "proc.opsCount": "{count} operasyon",
  "proc.pick": "Düzenlemek için bir reçete seçin ya da yeni bir reçete oluşturun.",
  "proc.code": "Kod",
  "proc.codeHint": "A–Z, 0–9, _ veya -. Sonradan değiştirilemez.",
  "proc.label": "Ad",
  "proc.makeBuy": "Yap / al",
  "proc.leadDays": "Varsayılan termin",
  "proc.days": "gün",
  "proc.ops": "Operasyonlar",
  "proc.col.op": "Op kodu",
  "proc.col.label": "Ad",
  "proc.col.setup": "Hazırlık sa",
  "proc.col.run": "İşleme sa/adet",
  "proc.col.machine": "Tezgâh",
  "proc.col.actions": "Sıra ve silme",
  "proc.addOp": "Operasyon ekle",
  "proc.moveUp": "Yukarı taşı",
  "proc.moveDown": "Aşağı taşı",
  "proc.removeOp": "Operasyonu kaldır",
  "proc.noOps": "Operasyon yok. Bir reçetede en az bir operasyon olmalı.",
  "proc.params": "Parametreler: {list}",
  "proc.save": "Değişiklikleri kaydet",
  "proc.create": "Reçeteyi oluştur",
  "proc.saving": "Kaydediliyor…",
  "proc.revert": "Değişiklikleri geri al",
  "proc.keep": "Vazgeç",
  "proc.saved": "Reçete kaydedildi. Yeni satırlar bundan sonra bunu kullanır.",
  "proc.created": "Reçete oluşturuldu.",
  "proc.delete": "Sil",
  "proc.deleteTitle": "{code} silinsin mi?",
  "proc.deleteBody": "Reçete kütüphaneden kaldırılır. Uygulandığı satırlar operasyonlarını korur.",
  "proc.deleted": "Reçete silindi.",
  "proc.reset": "Varsayılana döndür",
  "proc.resetTitle": "{code} varsayılana döndürülsün mü?",
  "proc.resetBody": "Bu reçetedeki değişiklikleriniz varsayılan değerlerle değiştirilir. Uygulandığı satırlar operasyonlarını korur.",
  "proc.resetDone": "Reçete varsayılana döndürüldü.",
  "proc.discardTitle": "Kaydedilmemiş değişiklikler atılsın mı?",
  "proc.discardBody": "Bu reçetedeki düzenlemeleriniz kaydedilmedi.",
  "proc.discard": "Değişiklikleri at",
  "proc.busy": "İşleniyor…",
  "proc.err.load": "Reçeteler yüklenemedi: {message}",
  "proc.err.generic": "İşlem tamamlanamadı: {message}",
  "proc.err.body": "İstek geçersiz.",
  "proc.err.fieldUnknown": "Bilinmeyen alan: {field}",
  "proc.err.code": "1–32 karakter kullanın: A–Z, 0–9, _ veya -; harf ya da rakamla başlamalı.",
  "proc.err.codeTaken": "Bu kodla bir reçete zaten var.",
  "proc.err.codeMismatch": "Kod bu reçeteyle eşleşmiyor.",
  "proc.err.label": "En fazla 120 karakterlik bir ad girin.",
  "proc.err.makeBuy": "İmalat, satın al veya dışarı seçin.",
  "proc.err.leadDays": "0 ile 365 arasında tam gün girin.",
  "proc.err.sortOrder": "Sıra 0 veya daha büyük bir tam sayı olmalı.",
  "proc.err.route": "Bir reçetede 1 ile 50 arasında operasyon olmalı.",
  "proc.err.op": "Bu operasyon geçersiz.",
  "proc.err.opCode": "Op kodu: 1–32 karakter, A–Z, 0–9, _ veya -.",
  "proc.err.opCodeDuplicate": "Bu op kodu bu reçetede zaten kullanılıyor.",
  "proc.err.hours": "Süreyi 0 ile 1000 arasında bir sayı olarak girin.",
  "proc.err.hoursDriven": "Bu süre operasyonun parametrelerinden hesaplanıyor ({value} sa). Bu değeri girin ya da parametreleri değiştirin.",
  "proc.err.opField": "{field} alanında geçersiz değer.",
  "proc.err.seeded": "Varsayılan reçeteler silinemez. Varsayılana döndürün.",
  "proc.err.notSeeded": "Yalnızca varsayılan reçeteler varsayılana döndürülebilir.",
  "proc.err.notFound": "Bu reçete artık yok.",
  // Agents page
  "sidebar.hint.agents": "RFQ ajanları ve sizi bekleyenler",
  "agents.subtitle": "Ajanlar her RFQ'yu okur, kontrol eder ve teklifi hazırlar. Bir kişinin karar vermesi gereken her yerde durur.",
  "agents.autorunOn": "Gelen mailde kendiliğinden başlar",
  "agents.autorunOff": "Bir RFQ'da siz başlatınca çalışır",
  "agents.waiting": "Sizi bekleyenler",
  "agents.waitingEmpty": "Ajanlar sizi beklemiyor.",
  "agents.waitingEmptyHint": "Bir RFQ, yalnızca bir kişinin yapabileceği bir adıma gelince burada görünür.",
  "agents.open": "Aç",
  "agents.untitled": "Başlıksız RFQ",
  "agents.working": "Devam edenler",
  "agents.workingQueued": "Sırada",
  "agents.workingRun": "Çalışıyor",
  "agents.workingJob": "Dosyalar okunuyor",
  "agents.failedLabel": "Durdu",
  "agents.failed": "Bir ajan hata verdi. RFQ'yu açıp ajanları yeniden çalıştırın.",
  "agents.inbox": "RFQ gelen kutusu",
  "agents.inboxHint": "Müşteriler RFQ'larını bu adrese gönderir. Her mail bir taslak RFQ açar.",
  "agents.inboxOff": "Bu çalışma alanında mail alımı kapalı.",
  "agents.inboxUnconfigured": "Gelen mail alan adı sunucuda henüz ayarlanmadı.",
  "agents.inboxError": "Adres yüklenemedi.",
  "agents.copy": "Kopyala",
  "agents.copied": "Kopyalandı",
  "agents.external": "Dış ajanlar",
  "agents.externalHint": "Bu bilgisayardaki Cursor veya Claude'u bağlayın. Okuyup iş hazırlayabilirler; onay ve gönderim burada kalır.",
  "agents.lineup": "Ajanlar ne yapar",
  "agents.lineupHint": "Her RFQ için bu sırayla. Maliyet bir ajan değil, düz hesaptır.",
  "agents.noStop": "Durmaz",
  "agents.step.intake.name": "Talep",
  "agents.step.intake.does": "Maili, tabloları, fotoğrafları ve çizimleri okur; talebi kalemlere ayırır.",
  "agents.step.intake.stop": "Taramadan okunan bir değer onayınızı bekler.",
  "agents.step.geometry.name": "Geometri",
  "agents.step.geometry.does": "Okuma yöntemleri çelişirse ölçüyü seçer ya da emin olmadığını söyler.",
  "agents.step.geometry.stop": "Okuma yöntemleri çelişiyor.",
  "agents.step.triage.name": "Triyaj",
  "agents.step.triage.does": "Eksikleri ve çelişkileri bulur, müşteriye gidecek soruyu taslak olarak yazar.",
  "agents.step.triage.stop": "Soruyu siz gönderirsiniz.",
  "agents.step.stock.name": "Malzeme ve stok",
  "agents.step.stock.does": "Stokla eşleştirir; müşteri onayı gereken bir ikame önerir.",
  "agents.step.make_buy.name": "Yap / satın al",
  "agents.step.make_buy.does": "Her kalemi planlar: atölyede yap ya da satın al, ve rota.",
  "agents.step.supplier.name": "Tedarik",
  "agents.step.supplier.does": "Satın alınan veya fasona giden kalemler için tedarikçi sorusunu taslak yazar.",
  "agents.step.supplier.stop": "Tedarikçi fiyatını bekler.",
  "agents.step.cost.name": "Maliyet",
  "agents.step.cost.does": "Düz hesap: hazırlık + işleme × adet, malzeme, işçilik ve tezgah.",
  "agents.step.audit.name": "Denetçi",
  "agents.step.audit.does": "Teklif içindeki çelişkileri yakalar; örneğin malzeme temininden kısa bir teslim süresi.",
  "agents.step.audit.stop": "Bir çelişkinin düzeltilmesi gerekir.",
  "agents.step.margin.name": "Marj",
  "agents.step.margin.does": "Kurallarınıza göre marj önerir.",
  "agents.step.margin.stop": "Marjı siz onaylarsınız.",
  "agents.step.send.name": "Gönderim",
  "agents.step.send.does": "Teklif hazırdır. Yalnızca bir kişi gönderir.",
  "agents.step.send.stop": "Teklifi siz gönderirsiniz.",
  "agents.gate.intake_pending": "Dosyalar hâlâ okunuyor",
  "agents.gate.parse_pending": "Bir çizim hâlâ okunuyor",
  "agents.gate.ocr_unconfirmed": "Taramadan okunan değerleri onaylayın",
  "agents.gate.intake_blocker": "Çelişen veya okunamayan dosyayı çözün",
  "agents.gate.no_lines": "Çizim, tablo veya kalem ekleyin",
  "agents.gate.parse_failed": "Bir çizim okunamadı; yeniden yükleyin",
  "agents.gate.geometry_uncertain": "Geometri kararını gözden geçirin",
  "agents.gate.customer_question": "Hazırlanan soruyu müşteriye gönderin",
  "agents.gate.supplier_reply": "Tedarikçi fiyatını girin",
  "agents.gate.audit_blocker": "Denetçinin bulduğunu düzeltin",
  "agents.gate.margin_approval": "Marjı onaylayın",
  "agents.gate.quote_send": "Teklifi gönderin",
  "agents.gate.unknown": "Sonraki adımı görmek için RFQ'yu açın",
};
